import { numberWithCommas } from './CommonUtils';
import { setPreferenceFlag } from '../actions/preferencesActions';
import downloadAppPNG from '../images/report-icons/ICON_dl-app.png';
import camera from '../images/report-icons/ICON_camera.png';
import airport from '../images/report-icons/ICON_airport.png';
import iPhonePNG from '../images/report-icons/ICON_iPhone.png';
import pcHomePNG from '../images/report-icons/ICON_pc_home.png';
import tabletPNG from '../images/report-icons/ICON_tablet.png';
import pcWorkPNG from '../images/report-icons/ICON_pc_work.png';
import pcBluePNG from '../images/report-icons/ICON_pc_blue.png';
// import gamingConsolePNG from '../images/report-icons/ICON_gaming-console.png';
import televisionPNG from '../images/report-icons/ICON_television.png';
import streamingMediaPNG from '../images/report-icons/ICON_streaming-media.png';
import smartphonePNG from '../images/report-icons/ICON_smartphone.png';
import socialPNG from '../images/report-icons/ICON_social.png';
import mp3playerPNG from '../images/report-icons/ICON_mp3player.png';
import eReaderPNG from '../images/report-icons/ICON_eReader.png';
// import famtravelerPNG from '../images/report-icons/ICON_fam-traveler.png';
import gamingConsoleOrigPNG from '../images/report-icons/ICON_gaming-console.png';
import gpsPNG from '../images/report-icons/ICON_GPS.png';
import homePNG from '../images/report-icons/ICON_home.png';
import hotelPNG from '../images/report-icons/ICON_hotel.png';
// import laptopPNG from '../images/report-icons/ICON_laptop.png';
import libraryPNG from '../images/report-icons/ICON_library.png';
import listenPNG from '../images/report-icons/ICON_listen.png';
import magazinePNG from '../images/report-icons/ICON_magazine.png';
import newspaperPNG from '../images/report-icons/ICON_newspaper.png';
// import nonePNG from '../images/report-icons/ICON_none.png';
import otherPNG from '../images/report-icons/ICON_other.png';
import radioPNG from '../images/report-icons/ICON_radio.png';
import radioAMFMPNG from '../images/report-icons/ICON_radio_AMFM.png';
import radioHDPNG from '../images/report-icons/ICON_radio_HD.png';
import radioSatellitePNG from '../images/report-icons/ICON_radio_satellite.png';
import restaurantPNG from '../images/report-icons/ICON_restaurant.png';
// import rssFeedPNG from '../images/report-icons/ICON_RSSfeed.png';
import schoolPNG from '../images/report-icons/ICON_school.png';
import streamVideoPNG from '../images/report-icons/ICON_stream-video.png';
import talkPNG from '../images/report-icons/ICON_talk.png';
import textMessagePNG from '../images/report-icons/ICON_text-message.png';
import watchDVDPNG from '../images/report-icons/ICON_watch-dvd.png';
import watchLivePNG from '../images/report-icons/ICON_watch-live.png';
import watchPPVPNG from '../images/report-icons/ICON_watch-PPV.png';
import watchRECPNG from '../images/report-icons/ICON_watch-REC.png';
import workPNG from '../images/report-icons/ICON_work.png';
// import worldTravelerPNG from '../images/report-icons/ICON_world_traveler.png';
import emailPNG from '../images/report-icons/ICON_email.png';
import chatPNG from '../images/report-icons/ICON_chat.png';
import browserPNG from '../images/report-icons/ICON_browser.png';
import audiobookPNG from '../images/report-icons/ICON_audio_book.png';
import webvisitPNG from '../images/report-icons/ICON_website_visit.png';
// import cameraPNG from '../images/report-icons/ICON_website_visit.png';
import Folder2 from '../images/folder-icon.png';
import Folder from '../images/report-icons/website-earth-icon.png';

import pcPNG from '../images/report-icons/pc-icon.png';
import pcmPNG from '../images/report-icons/pc-mobile-icon.png';
import mPNG from '../images/report-icons/cell-tablet-icon_cc.png';

//  Day In Life Icons
import cameraDayPNG from '../images/report-icons/dayinlife/camera-icon_#247ba0.png';
import chatDayPNG from '../images/report-icons/dayinlife/chat-icon_#008490.png';
import downloadAppDayPNG from '../images/report-icons/dayinlife/download-app-icon_#f25f5c.png';
import emailDayPNG from '../images/report-icons/dayinlife/email-icon_#ffe066.png';
import gamesDayPNG from '../images/report-icons/dayinlife/games-icon_#94d3dc.png';
import gpsDayPNG from '../images/report-icons/dayinlife/gps-icon_#4ecdc4.png';
import messagingDayPNG from '../images/report-icons/dayinlife/messaging-icon_#e1d2a5.png';
import musicDayPNG from '../images/report-icons/dayinlife/music-icon_#f67451.png';
import socialNetworkDayPNG from '../images/report-icons/dayinlife/social-network-icon_#5ca4a9.png';
import talkDayPNG from '../images/report-icons/dayinlife/talk-icon_#fab266.png';
import videoDayPNG from '../images/report-icons/dayinlife/video-icon_#bebebe.png';
import websiteEarthDayPNG from '../images/report-icons/dayinlife/website-earth-icon_#991a41.png';
import {
  PREFERENCE_QUICKREPORTS,
  PREFERENCE_STUDY_WEIGHTING,
  QUICKREPORTS_CONSTANT,
  MRI_STUDY_WARNING_TYPE_6,
  MRI_STUDY_WARNING_TYPE_7,
  MRI_STUDY_WARNING_TYPE_8,
} from '../constants';

export const IMAGES = {
  ICON_downloadApp: downloadAppPNG,
  ICON_gamingConsole: gamingConsoleOrigPNG,
  ICON_socialNetwork: socialPNG,
  ICON_camera: camera,
  ICON_airport: airport,
  ICON_iPhone: iPhonePNG,
  ICON_pc_home: pcHomePNG,
  ICON_tablet: tabletPNG,
  ICON_pc_work: pcWorkPNG,
  ICON_mp3player: mp3playerPNG,
  ICON_gaming_console: gamingConsoleOrigPNG,
  ICON_television: televisionPNG,
  ICON_streaming_media: streamingMediaPNG,
  ICON_smartphone: smartphonePNG,
  ICON_social: socialPNG,
  ICON_email: emailPNG,
  ICON_chat: chatPNG,
  ICON_magazine: magazinePNG,
  ICON_browser: browserPNG,
  ICON_stream_video: streamVideoPNG,
  ICON_eReader: eReaderPNG,
  // ICON_fam_traveler: famtravelerPNG,
  ICON_gaming_console_orig: gamingConsoleOrigPNG,
  ICON_GPS: gpsPNG,
  ICON_home: homePNG,
  ICON_hotel: hotelPNG,
  // ICON_laptop: laptopPNG,
  ICON_library: libraryPNG,
  ICON_listen: listenPNG,
  ICON_newspaper: newspaperPNG,
  // ICON_none: nonePNG,
  ICON_other: otherPNG,
  ICON_radio: radioPNG,
  ICON_radio_AMFM: radioAMFMPNG,
  ICON_radio_HD: radioHDPNG,
  ICON_radio_satellite: radioSatellitePNG,
  ICON_restaurant: restaurantPNG,
  // ICON_RSSfeed: rssFeedPNG,
  ICON_school: schoolPNG,
  ICON_talk: talkPNG,
  ICON_text_message: textMessagePNG,
  ICON_watch_dvd: watchDVDPNG,
  ICON_watch_live: watchLivePNG,
  ICON_watch_PPV: watchPPVPNG,
  ICON_watch_REC: watchRECPNG,
  ICON_work: workPNG,
  // ICON_world_traveler: worldTravelerPNG,
  ICON_audio_book: audiobookPNG,
  ICON_website_visit: webvisitPNG,
  ICON_DAY_camera: cameraDayPNG,
  ICON_DAY_chat: chatDayPNG,
  ICON_DAY_downloadApp: downloadAppDayPNG,
  ICON_DAY_email: emailDayPNG,
  ICON_DAY_games: gamesDayPNG,
  ICON_DAY_gps: gpsDayPNG,
  ICON_DAY_messaging: messagingDayPNG,
  ICON_DAY_music: musicDayPNG,
  ICON_DAY_socialNetwork: socialNetworkDayPNG,
  ICON_DAY_talk: talkDayPNG,
  ICON_DAY_video: videoDayPNG,
  ICON_DAY_websiteEarth: websiteEarthDayPNG,
  ICON_Folder: Folder,
  ICON_Folder2: Folder2,
  ICON_pcm: pcmPNG,
  ICON_pc: pcPNG,
  ICON_pc_blue: pcBluePNG,
  ICON_m: mPNG,
};

export const DAY_IN_LIFE_ICONS = {
  Camera: { icon: IMAGES.ICON_DAY_camera, color: '#247ba0' },
  'Download Apps': { icon: IMAGES.ICON_DAY_downloadApp, color: '#f25f5c' },
  Email: { icon: IMAGES.ICON_DAY_email, color: '#ffe066' },
  GPS: { icon: IMAGES.ICON_DAY_gps, color: '#4ecdc4' },
  IM: { icon: IMAGES.ICON_DAY_chat, color: '#008490' },
  'Listen to Music': { icon: IMAGES.ICON_DAY_music, color: '#f67451' },
  Messaging: { icon: IMAGES.ICON_DAY_messaging, color: '#e1d2a5' },
  'Play Games': { icon: IMAGES.ICON_DAY_games, color: '#94d3dc' },
  'Social Network': { icon: IMAGES.ICON_DAY_socialNetwork, color: '#5ca4a9' },
  Talk: { icon: IMAGES.ICON_DAY_talk, color: '#fab266' },
  Video: { icon: IMAGES.ICON_DAY_video, color: '#bebebe' },
  Websites: { icon: IMAGES.ICON_DAY_websiteEarth, color: '#991a41' },
};

export const TIME_SPENT_ICONS = {
  'E-Reader': IMAGES.ICON_eReader,
  'Game Console': IMAGES.ICON_gaming_console_orig,
  'Mobile Phone': IMAGES.ICON_iPhone,
  Magazines: IMAGES.ICON_magazine,
  MP3: IMAGES.ICON_mp3player,
  Newspapers: IMAGES.ICON_newspaper,
  'PC at Home': IMAGES.ICON_pc_home,
  'PC at Work': IMAGES.ICON_pc_work,
  Radio: IMAGES.ICON_radio,
  Tablet: IMAGES.ICON_tablet,
  Television: IMAGES.ICON_television,
  'Streaming Media': IMAGES.ICON_streaming_media,
};

export const TIME_SPENT_INDEX = {
  'E-Reader': 0,
  'Game Console': 1,
  Magazines: 2,
  'Mobile Phone': 3,
  Newspapers: 4,
  'PC at Home': 5,
  'PC at Work': 6,
  Radio: 7,
  Tablet: 8,
  Television: 9,
  'Streaming Media': 10,
};

export const REACH_ICONS = {
  'E-Reader': { imgLable: IMAGES.ICON_eReader, color: '#F25F5C' },
  'Game Console': {
    imgLable: IMAGES.ICON_gaming_console_orig,
    color: '#008490',
  },
  Magazines: { imgLable: IMAGES.ICON_magazine, color: '#E1D2A5' },
  'Mobile Phone': { imgLable: IMAGES.ICON_iPhone, color: '#247BA0' },
  MP3: { imgLable: IMAGES.ICON_mp3player, color: '#4ECDC4' },
  Newspapers: { imgLable: IMAGES.ICON_newspaper, color: '#FAB266' },
  'PC at Home': { imgLable: IMAGES.ICON_pc_home, color: '#94D3DC' },
  'PC at Work': { imgLable: IMAGES.ICON_pc_work, color: '#FFE066' },
  Radio: { imgLable: IMAGES.ICON_radio, color: '#F67451' },
  Tablet: { imgLable: IMAGES.ICON_tablet, color: '#5CA4A9' },
  Television: { imgLable: IMAGES.ICON_television, color: '#F25F5C' },
  'Streaming Media': {
    imgLable: IMAGES.ICON_streaming_media,
    color: '#008490',
  },
};

export const MAAP_ICONS = {
  'E-mail': {
    Tablet: { imgLable: IMAGES.ICON_tablet, color: '#5CA4A9' },
    'E-Reader': { imgLable: IMAGES.ICON_eReader, color: '#F25F5C' },
    Smartphone: { imgLable: IMAGES.ICON_smartphone, color: '#4ECDC4' },
    'PC at Home': { imgLable: IMAGES.ICON_pc_home, color: '#94D3DC' },
    'PC at Work': { imgLable: IMAGES.ICON_pc_work, color: '#FFE066' },
  },
  Camera: {
    Smartphone: { imgLable: IMAGES.ICON_smartphone, color: '#4ECDC4' },
    Tablet: { imgLable: IMAGES.ICON_tablet, color: '#5CA4A9' },
  },
  'Download Apps': {
    Smartphone: { imgLable: IMAGES.ICON_smartphone, color: '#4ECDC4' },
    Tablet: { imgLable: IMAGES.ICON_tablet, color: '#5CA4A9' },
  },
  GPS: {
    Smartphone: { imgLable: IMAGES.ICON_smartphone, color: '#4ECDC4' },
    Tablet: { imgLable: IMAGES.ICON_tablet, color: '#5CA4A9' },
  },
  'IM/Chat': {
    Tablet: { imgLable: IMAGES.ICON_tablet, color: '#5CA4A9' },
    'Game Console': {
      imgLable: IMAGES.ICON_gaming_console_orig,
      color: '#008490',
    },
    Smartphone: { imgLable: IMAGES.ICON_smartphone, color: '#4ECDC4' },
    'PC at Home': { imgLable: IMAGES.ICON_pc_home, color: '#94D3DC' },
    'PC at Work': { imgLable: IMAGES.ICON_pc_work, color: '#FFE066' },
  },
  'Listen to AM/FM Radio': {
    Radio: { imgLable: IMAGES.ICON_radio_AMFM, color: '#F67451' },
  },
  'Listen to Audio Books': {
    'E-Reader': { imgLable: IMAGES.ICON_eReader, color: '#F25F5C' },
  },
  'Listen to HD Radio': {
    Radio: { imgLable: IMAGES.ICON_radio_HD, color: '#F67451' },
  },
  'Listen to Music': {
    Tablet: { imgLable: IMAGES.ICON_tablet, color: '#5CA4A9' },
    'E-Reader': { imgLable: IMAGES.ICON_eReader, color: '#F25F5C' },
    Smartphone: { imgLable: IMAGES.ICON_smartphone, color: '#4ECDC4' },
    'Streaming Media': {
      imgLable: IMAGES.ICON_streaming_media,
      color: '#008490',
    },
    'PC at Home': { imgLable: IMAGES.ICON_pc_home, color: '#94D3DC' },
    'PC at Work': { imgLable: IMAGES.ICON_pc_work, color: '#FFE066' },
    Television: { imgLable: IMAGES.ICON_television, color: '#F25F5C' },
    'Game Console': {
      imgLable: IMAGES.ICON_gaming_console_orig,
      color: '#008490',
    },
    MP3: { imgLable: IMAGES.ICON_mp3player, color: '#4ECDC4' },
  },
  'Listen to Other Audio Content': {
    'E-Reader': { imgLable: IMAGES.ICON_eReader, color: '#F25F5C' },
  },
  'Listen to Satellite Radio': {
    Radio: { imgLable: IMAGES.ICON_radio, color: '#F67451' },
  },
  'Play DVDs or Blu-rays': {
    'Game Console': {
      imgLable: IMAGES.ICON_gaming_console_orig,
      color: '#008490',
    },
    Television: { imgLable: IMAGES.ICON_television, color: '#F25F5C' },
  },
  'Play Games': {
    Tablet: { imgLable: IMAGES.ICON_tablet, color: '#5CA4A9' },
    'E-Reader': { imgLable: IMAGES.ICON_eReader, color: '#F25F5C' },
    'Game Console': {
      imgLable: IMAGES.ICON_gaming_console_orig,
      color: '#008490',
    },
    Smartphone: { imgLable: IMAGES.ICON_smartphone, color: '#4ECDC4' },
    'Streaming Media': {
      imgLable: IMAGES.ICON_streaming_media,
      color: '#008490',
    },
    'PC at Home': { imgLable: IMAGES.ICON_pc_home, color: '#94D3DC' },
    'PC at Work': { imgLable: IMAGES.ICON_pc_work, color: '#FFE066' },
    Television: { imgLable: IMAGES.ICON_television, color: '#F25F5C' },
    MP3: { imgLable: IMAGES.ICON_mp3player, color: '#4ECDC4' },
  },
  'Read Media': {
    Tablet: { imgLable: IMAGES.ICON_tablet, color: '#5CA4A9' },
    'E-Reader': { imgLable: IMAGES.ICON_eReader, color: '#F25F5C' },
    Smartphone: { imgLable: IMAGES.ICON_smartphone, color: '#4ECDC4' },
    'PC at Home': { imgLable: IMAGES.ICON_pc_home, color: '#94D3DC' },
    'PC at Work': { imgLable: IMAGES.ICON_pc_work, color: '#FFE066' },
  },
  'Social Network/Blog': {
    Tablet: { imgLable: IMAGES.ICON_tablet, color: '#5CA4A9' },
    'Game Console': {
      imgLable: IMAGES.ICON_gaming_console_orig,
      color: '#008490',
    },
    Smartphone: { imgLable: IMAGES.ICON_smartphone, color: '#4ECDC4' },
    'Streaming Media': {
      imgLable: IMAGES.ICON_streaming_media,
      color: '#008490',
    },
    'PC at Home': { imgLable: IMAGES.ICON_pc_home, color: '#94D3DC' },
    'PC at Work': { imgLable: IMAGES.ICON_pc_work, color: '#FFE066' },
    Television: { imgLable: IMAGES.ICON_television, color: '#F25F5C' },
    MP3: { imgLable: IMAGES.ICON_mp3player, color: '#4ECDC4' },
  },
  Talk: {
    Smartphone: { imgLable: IMAGES.ICON_smartphone, color: '#4ECDC4' },
    Tablet: { imgLable: IMAGES.ICON_tablet, color: '#5CA4A9' },
  },
  Text: {
    Smartphone: { imgLable: IMAGES.ICON_smartphone, color: '#4ECDC4' },
    Tablet: { imgLable: IMAGES.ICON_tablet, color: '#5CA4A9' },
  },
  'Visit Websites': {
    Tablet: { imgLable: IMAGES.ICON_tablet, color: '#5CA4A9' },
    'E-Reader': { imgLable: IMAGES.ICON_eReader, color: '#F25F5C' },
    'Game Console': {
      imgLable: IMAGES.ICON_gaming_console_orig,
      color: '#008490',
    },
    Smartphone: { imgLable: IMAGES.ICON_smartphone, color: '#4ECDC4' },
    'Streaming Media': {
      imgLable: IMAGES.ICON_streaming_media,
      color: '#008490',
    },
    'PC at Home': { imgLable: IMAGES.ICON_pc_home, color: '#94D3DC' },
    'PC at Work': { imgLable: IMAGES.ICON_pc_work, color: '#FFE066' },
    Television: { imgLable: IMAGES.ICON_television, color: '#F25F5C' },
    MP3: { imgLable: IMAGES.ICON_mp3player, color: '#4ECDC4' },
  },
  'Watch Live TV': {
    'Game Console': {
      imgLable: IMAGES.ICON_gaming_console_orig,
      color: '#008490',
    },
    Television: { imgLable: IMAGES.ICON_television, color: '#F25F5C' },
  },
  'Watch Recorded TV on a DVR': {
    Television: { imgLable: IMAGES.ICON_television, color: '#F25F5C' },
  },
  'Watch Downloaded/Streamed Video': {
    'Game Console': {
      imgLable: IMAGES.ICON_gaming_console_orig,
      color: '#008490',
    },
    'PC at Home': { imgLable: IMAGES.ICON_pc_home, color: '#94D3DC' },
    'PC at Work': { imgLable: IMAGES.ICON_pc_work, color: '#FFE066' },
    Smartphone: { imgLable: IMAGES.ICON_smartphone, color: '#4ECDC4' },
    'Streaming Media': {
      imgLable: IMAGES.ICON_streaming_media,
      color: '#008490',
    },
    Television: { imgLable: IMAGES.ICON_television, color: '#F25F5C' },
    Tablet: { imgLable: IMAGES.ICON_tablet, color: '#5CA4A9' },
  },
  'Watch Video on Demand': {
    Television: { imgLable: IMAGES.ICON_television, color: '#F25F5C' },
  },
};

export const MPAA_ICONS = {
  'E-Reader': {
    Email: { imgLable: IMAGES.ICON_email, color: '#247BA0' },
    'Listen to Audio Books': {
      imgLable: IMAGES.ICON_audio_book,
      color: '#4ECDC4',
    },
    'Listen to Music': { imgLable: IMAGES.ICON_listen, color: '#F25F5C' },
    'Listen to Other Audio': { imgLable: IMAGES.ICON_listen, color: '#FFE066' },
    'Play Games': {
      imgLable: IMAGES.ICON_gaming_console_orig,
      color: '#008490',
    },
    'Read E-Books': { imgLable: IMAGES.ICON_eReader, color: '#F67451' },
    'Read Magazines': { imgLable: IMAGES.ICON_magazine, color: '#E1D2A5' },
    'Read Newspapers': { imgLable: IMAGES.ICON_newspaper, color: '#FAB266' },
    'Visit Websites': { imgLable: IMAGES.ICON_browser, color: '#94D3DC' },
    Other: { imgLable: IMAGES.ICON_other, color: '#5CA4A9' },
  },
  'Game Console': {
    'IM/CHAT': { imgLable: IMAGES.ICON_chat, color: '#E1D2A5' },
    'Listen to Music': { imgLable: IMAGES.ICON_listen, color: '#F25F5C' },
    'Play DVDs or Blu-Rays': {
      imgLable: IMAGES.ICON_watch_dvd,
      color: '#F67451',
    },
    'Play Games': {
      imgLable: IMAGES.ICON_gaming_console_orig,
      color: '#008490',
    },
    'Social Network/Blog': { imgLable: IMAGES.ICON_social, color: '#FFE066' },
    'Visit Websites': { imgLable: IMAGES.ICON_browser, color: '#94D3DC' },
    'Watch Downloaded/Streamed Video': {
      imgLable: IMAGES.ICON_stream_video,
      color: '#4ECDC4',
    },
    'Watch Live TV': { imgLable: IMAGES.ICON_watch_live, color: '#247BA0' },
    Other: { imgLable: IMAGES.ICON_other, color: '#5CA4A9' },
  },
  'PC at Home': {
    EMail: { imgLable: IMAGES.ICON_email, color: '#247BA0' },
    'IM/Chat': { imgLable: IMAGES.ICON_chat, color: '#F25F5C' },
    'Listen to Music': { imgLable: IMAGES.ICON_listen, color: '#F25F5C' },
    'Play Games': {
      imgLable: IMAGES.ICON_gaming_console_orig,
      color: '#008490',
    },
    'Read E-Books': { imgLable: IMAGES.ICON_eReader, color: '#F67451' },
    'Read Magazines': { imgLable: IMAGES.ICON_magazine, color: '#E1D2A5' },
    'Read Newspapers': { imgLable: IMAGES.ICON_newspaper, color: '#FAB266' },
    'Social Network/Blog': { imgLable: IMAGES.ICON_social, color: '#FFE066' },
    'Visit Websites': { imgLable: IMAGES.ICON_browser, color: '#94D3DC' },
    'Watch Downloaded/Streamed Video': {
      imgLable: IMAGES.ICON_stream_video,
      color: '#4ECDC4',
    },
    Other: { imgLable: IMAGES.ICON_other, color: '#5CA4A9' },
  },
  'PC at Work': {
    Email: { imgLable: IMAGES.ICON_email, color: '#247BA0' },
    'IM/Chat': { imgLable: IMAGES.ICON_chat, color: '#E1D2A5' },
    'Listen to Music': { imgLable: IMAGES.ICON_listen, color: '#F25F5C' },
    'Play Games': {
      imgLable: IMAGES.ICON_gaming_console_orig,
      color: '#008490',
    },
    'Read E-Books': { imgLable: IMAGES.ICON_eReader, color: '#F67451' },
    'Read Magazines': { imgLable: IMAGES.ICON_magazine, color: '#E1D2A5' },
    'Read Newspapers': { imgLable: IMAGES.ICON_newspaper, color: '#FAB266' },
    'Social Network/Blog': { imgLable: IMAGES.ICON_social, color: '#FFE066' },
    'Visit Websites': { imgLable: IMAGES.ICON_browser, color: '#94D3DC' },
    'Watch Downloaded/Streamed Video': {
      imgLable: IMAGES.ICON_stream_video,
      color: '#4ECDC4',
    },
    Other: { imgLable: IMAGES.ICON_other, color: '#5CA4A9' },
  },
  Radio: {
    'Listen to AM/FM Radio': {
      imgLable: IMAGES.ICON_radio_AMFM,
      color: '#F25F5C',
    },
    'Listen to HD Radio': { imgLable: IMAGES.ICON_radio_HD, color: '#4ECDC4' },
    'Listen to Satellite Radio': {
      imgLable: IMAGES.ICON_radio_satellite,
      color: '#F67451',
    },
    Other: { imgLable: IMAGES.ICON_other, color: '#5CA4A9' },
  },
  Smartphone: {
    Camera: { imgLable: IMAGES.ICON_camera, color: '#F25F5C' },
    'Download App': { imgLable: IMAGES.ICON_downloadApp, color: '#F25F5C' },
    EMail: { imgLable: IMAGES.ICON_email, color: '#247BA0' },
    GPS: { imgLable: IMAGES.ICON_GPS, color: '#4ECDC4' },
    'IM/Chat': { imgLable: IMAGES.ICON_chat, color: '#E1D2A5' },
    'Listen to Music': { imgLable: IMAGES.ICON_listen, color: '#F25F5C' },
    'Play Games': {
      imgLable: IMAGES.ICON_gaming_console_orig,
      color: '#008490',
    },
    'Read Newspapers': { imgLable: IMAGES.ICON_newspaper, color: '#FAB266' },
    'Social Network/Blog': { imgLable: IMAGES.ICON_social, color: '#FFE066' },
    Talk: { imgLable: IMAGES.ICON_talk, color: '#FFE066' },
    'Text/Picture/Video Message': {
      imgLable: IMAGES.ICON_text_message,
      color: '#E1D2A5',
    },
    'Visit Websites': { imgLable: IMAGES.ICON_browser, color: '#94D3DC' },
    'Watch Downloaded/Streamed Video': {
      imgLable: IMAGES.ICON_stream_video,
      color: '#4ECDC4',
    },
  },
  'Streaming Media': {
    'Listen to Music': { imgLable: IMAGES.ICON_listen, color: '#F25F5C' },
    'Play Games': {
      imgLable: IMAGES.ICON_gaming_console_orig,
      color: '#008490',
    },
    'Social Network/Blog': { imgLable: IMAGES.ICON_social, color: '#FFE066' },
    'Visit Websites': { imgLable: IMAGES.ICON_browser, color: '#94D3DC' },
    'Watch Downloaded/Streamed Video': {
      imgLable: IMAGES.ICON_stream_video,
      color: '#4ECDC4',
    },
    Other: { imgLable: IMAGES.ICON_other, color: '#5CA4A9' },
  },
  Tablet: {
    Camera: { imgLable: IMAGES.ICON_camera, color: '#F25F5C' },
    'Download App': { imgLable: IMAGES.ICON_downloadApp, color: '#F25F5C' },
    EMail: { imgLable: IMAGES.ICON_email, color: '#247BA0' },
    GPS: { imgLable: IMAGES.ICON_GPS, color: '#4ECDC4' },
    'IM/Chat': { imgLable: IMAGES.ICON_chat, color: '#E1D2A5' },
    'Listen to Music': { imgLable: IMAGES.ICON_listen, color: '#F25F5C' },
    'Play Games': {
      imgLable: IMAGES.ICON_gaming_console_orig,
      color: '#008490',
    },
    'Read Newspapers': { imgLable: IMAGES.ICON_newspaper, color: '#FAB266' },
    'Social Network/Blog': { imgLable: IMAGES.ICON_social, color: '#FFE066' },
    Talk: { imgLable: IMAGES.ICON_talk, color: '#FFE066' },
    'Text/Picture/Video Message': {
      imgLable: IMAGES.ICON_text_message,
      color: '#E1D2A5',
    },
    'Visit Websites': { imgLable: IMAGES.ICON_browser, color: '#94D3DC' },
    'Watch Downloaded/Streamed Video': {
      imgLable: IMAGES.ICON_stream_video,
      color: '#4ECDC4',
    },
  },
  Television: {
    'Listen To Music': { imgLable: IMAGES.ICON_listen, color: '#F25F5C' },
    "Play DVD's or Blu-Rays": {
      imgLable: IMAGES.ICON_watch_dvd,
      color: '#F67451',
    },
    'Play Games': {
      imgLable: IMAGES.ICON_gaming_console_orig,
      color: '#008490',
    },
    'Social Network/Blog': { imgLable: IMAGES.ICON_social, color: '#FFE066' },
    'Visit Websites': { imgLable: IMAGES.ICON_browser, color: '#94D3DC' },
    'Watch Downloaded/Streamed Video': {
      imgLable: IMAGES.ICON_stream_video,
      color: '#4ECDC4',
    },
    'Watch Live TV': { imgLable: IMAGES.ICON_watch_live, color: '#247BA0' },
    'Watch Recorded TV on a DVR': {
      imgLable: IMAGES.ICON_watch_REC,
      color: '#008490',
    },
    'Watch Video on Demand': {
      imgLable: IMAGES.ICON_watch_PPV,
      color: '#94D3DC',
    },
    Other: { imgLable: IMAGES.ICON_other, color: '#5CA4A9' },
  },
};

export const DYNAMIC_REPORT_TYPES = {
  DIL_S_ALL: 'DIL_S_ALL',
  DIL_S_WKDAY: 'DIL_S_ALL',
  DIL_S_WKEND: 'DIL_S_ALL',
  DIL_S_1: 'DIL_S_ALL',
  DIL_S_2: 'DIL_S_ALL',
  DIL_S_3: 'DIL_S_ALL',
  DIL_S_4: 'DIL_S_ALL',
  DIL_S_5: 'DIL_S_ALL',
  DIL_S_6: 'DIL_S_ALL',
  DIL_S_7: 'DIL_S_ALL',
  DIL_C_ALL: 'DIL_S_ALL',
  DIL_C_WKDAY: 'DIL_S_ALL',
  DIL_C_WKEND: 'DIL_S_ALL',
  DIL_C_1: 'DIL_S_ALL',
  DIL_C_2: 'DIL_S_ALL',
  DIL_C_3: 'DIL_S_ALL',
  DIL_C_4: 'DIL_S_ALL',
  DIL_C_5: 'DIL_S_ALL',
  DIL_C_6: 'DIL_S_ALL',
  DIL_C_7: 'DIL_S_ALL',
  WEBR_7D: 'WEBR_7',
  WEBR_30: 'WEBR_7',
  WEBR_30D: 'WEBR_7',
  CCAT_30: 'CCAT_7',
  CCAT_7D: 'CCAT_7',
  CCAT_30D: 'CCAT_7',
};

export const REPORT_TYPES = [
  {
    key: 'DEMOPROFILE',
    name: 'Demographic Profile',
    style: 'demo-profile',
    isForAllStudy: true,
    exportFileTitle: 'Demographic_Profile',
  },
  {
    key: 'SEGMENTATION',
    name: 'Segmentation',
    style: 'segment',
    isForAllStudy: true,
    exportFileTitle: 'Segmentation',
  },
  {
    key: 'MAP',
    name: 'Maps',
    style: 'maps',
    isForAllStudy: true,
    exportFileTitle: 'Maps',
  },
  {
    key: 'TIMESPENT',
    name: 'Time Spent Composition',
    style: 'time-spent',
    exportFileTitle: 'Time_Spent_Composition_Last_7_Days',
  },
  {
    key: 'DAP',
    name: 'Digital Activity Profile',
    style: 'dap',
    exportFileTitle: 'Digital_Activity_Report',
  },
  {
    key: 'REACH',
    name: 'Reach',
    style: 'reach',
    subType: '7Days',
    exportFileTitle: 'Reach',
  },
  {
    key: 'IREACH',
    name: 'Incremental Reach Builder',
    style: 'inc-reach',
    exportFileTitle: 'Incremental_Reach_Builder',
  },
  {
    key: 'MAAP',
    name: 'Media Activity Across Platforms',
    style: 'maap',
    subType: 'camera',
    exportFileTitle: 'Media_Activity_Across_Platforms',
  },
  {
    key: 'MPAA',
    name: 'Media Platform Across Activities',
    style: 'mpaa',
    subType: 'ereader',
    exportFileTitle: 'Media_Platform_Across_Activities',
  },
  {
    key: 'SIM',
    name: 'Simultaneous Usage While Watching TV',
    style: 'sim-usage',
    exportFileTitle: 'Simultaneous_Usage_-_TV_Base',
  },
  {
    key: 'DIL_S_ALL',
    name: 'Day In The Life',
    style: 'day-life',
    exportFileTitle: 'Day_In_The_Life',
  },
  {
    key: 'SMAP',
    name: 'Social Media Activity Profile',
    style: 'social-media',
    exportFileTitle: 'Social_Media_Activity_Profile',
  },
  {
    key: 'CCAT_7',
    name: 'Channel Category',
    style: 'channel-cat',
    exportFileTitle: 'Channel_Category',
  },
  {
    key: 'WEBR_7',
    name: 'Website Visitation',
    style: 'web-vist',
    exportFileTitle: 'Website_Visitation_by_Percentage',
  },
];

export const REPORT_TYPES_MAPPED = {
  DEMOPROFILE: 'DEMOPROFILE',
  SEGMENTATION: 'SEGMENTATION',
  MAP: 'MAP',
  TIMESPENT: 'TIMESPENT',
  DIGITALACTIVITY: 'DAP',
  REACH: 'REACH',
  IREACH: 'IREACH',
  MAAP: 'MAAP',
  MPAA: 'MPAA',
  SIM: 'SIM',
  DAYLIFE: 'DIL_S_ALL',
  SMAP: 'SMAP',
  CHANCAT: 'CCAT_7',
  WEBVIS: 'WEBR_7',
};

const TOOLTIP = {
  Sample: 'Sample: {point.value.asterisk}{point.value.sample}',
  Weighted: 'Weighted: {point.value.asterisk}{point.value.weighted}',
  Percent: 'Percent: {point.value.asterisk}{point.value.pct}%',
  Indx: 'Index: {point.value.asterisk}{point.value.index}',
  Vertical: 'Vertical: {point.value.asterisk}{point.value.vertical}%',
};

export const labelToolTips = (
  label,
  sample,
  weighted,
  pct,
  index
  // showSingleAsterisk,
  // showDoubleAsterisk,
) => {
  if (sample < 31) {
    return `${label} \nSample: **${sample} \nWeighted: **${weighted} \nPercent: **${pct} \nIndex: **${index}`;
  }
  if (sample < 61) {
    return `${label} \nSample: *${sample} \nWeighted: *${weighted} \nPercent: *${pct} \nIndex: *${index}`;
  }
  return `${label} \nSample: ${sample} \nWeighted: ${weighted} \nPercent: ${pct} \nIndex: ${index}`;
};

export const filterAsterisk = item => {
  if (item.value.sample < 31) {
    return `**${item.value.index}`;
  }
  if (item.value.sample < 61) {
    return `*${item.value.index}`;
  }
  return `${item.value.index}`;
};

export const calculateAsterisk = sample => {
  if (sample < 31) {
    return '**';
  }
  if (sample < 61) {
    return '*';
  }
  return '';
};

export const checkAsterickFormate = (
  data,
  isDoubleAsterisk,
  isSingleAsterisk
) => {
  // console.log("Double asteric value "+ isDoubleAsterisk
  // +"  single asteric value "+ isSingleAsterisk);
  if (isDoubleAsterisk) {
    return `** ${data}`;
  }
  if (isSingleAsterisk) {
    return `* ${data}`;
  }
  return data;
};

export const calculateMRIAsterisk = (sample, warningType) => {
  if (warningType === MRI_STUDY_WARNING_TYPE_6 && sample < 50) {
    return '*';
  }
  if (warningType === MRI_STUDY_WARNING_TYPE_7) {
    if (sample < 25) {
      return '**';
    }
    if (sample < 50) {
      return '*';
    }
  } else if (warningType === MRI_STUDY_WARNING_TYPE_8) {
    if (sample < 31) {
      return '**';
    }
    if (sample < 60) {
      return '*';
    }
  }
  return '';
};

const calculateColor = (value, colorValue, maxColor, minColor) => {
  if (value >= colorValue) {
    return maxColor;
  }
  return minColor;
};

const ignoreDataOnChart = {
  'Do Not Own Cell Phone': true,
};

export const processIcons = (icons, removedBar, hideIcon) => {
  return Object.keys(icons).reduce(
    (accumulator, icon) => ({
      ...accumulator,
      [icon]: hideIcon[icon]
        ? icon
        : `<img width="40px" src=${icons[icon].imgLable} /><br />${icon}`,
    }),
    {}
  );
};
const filterData = (Data, icon) => {
  let outPut = '';
  Data.forEach(element => {
    // console.log(" final label "+element.label + " Icon value "+icon +
    // " "+element.label.indexOf(icon) +" val "+ element.value.hours +"
    // include "+element.label.includes(icon));
    if (element.label === icon || element.label.includes(icon)) {
      outPut = element.value.hours;
      return false;
    }
    return true;
  });
  // console.log("icon "+icon +" value "+outPut);
  return outPut;
};
const checkIcondName = (icon, rename) => {
  if (typeof rename[icon] !== 'undefined') {
    return rename[icon];
  }
  return icon;
};
export const processLableVal = (
  icons,
  averageData,
  remove,
  hideIcon,
  rename,
  processLabel,
  icon
) => {
  let output = '';
  if (icons[icon]) {
    output = `<img width="40px" src=${icons[icon]} /><br />${checkIcondName(
      icon,
      rename
    )}<br /><label title="Average Time Spent in Hours">${filterData(
      averageData,
      icon,
      remove,
      hideIcon,
      rename
    )}</label>`;
  } else {
    output = `${icon}<br/><label title="Average Time Spent in Hours">${filterData(
      averageData,
      icon,
      remove,
      hideIcon,
      rename
    )}</label>`;
  }
  return output;
};
export const processTimeSpentIcons = (
  icons,
  averageData,
  remove,
  hideIcon,
  rename,
  processLabel
) => {
  const out = processLabel.reduce(
    (accumulator, icon) => ({
      ...accumulator,
      [icon]: hideIcon[icon]
        ? `${icon}<br/><label title="Average Time Spent in Hours">${filterData(
            averageData,
            icon,
            remove,
            hideIcon,
            rename
          )}</label>`
        : processLableVal(
            icons,
            averageData,
            remove,
            hideIcon,
            rename,
            processLabel,
            icon
          ),
    }),
    {}
  );
  // console.log(" Inside process Timespent Icons ");
  return out;
};

export const isMRISpecificStudy = studyInfo => {
  return studyInfo && studyInfo.ss ? studyInfo.ss.includes('MRI') : false;
};

export const processData = (
  data,
  updateAsteriskStatus,
  study,
  removeLabel = {},
  renameLabel = {}
) =>
  data.rawData.reduce((accumulator, currentvalue) => {
    // console.log(" colore label "+colLabel);
    const isMRIStudy = isMRISpecificStudy(study);
    let asterisk;
    if (isMRIStudy) {
      asterisk = calculateMRIAsterisk(
        currentvalue.value.sample,
        study.warningType
      );
    } else {
      asterisk = calculateAsterisk(currentvalue.value.sample);
    }
    const name = renameLabel[currentvalue[data.name || 'label']]
      ? renameLabel[currentvalue[data.name || 'label']]
      : currentvalue[data.name || 'label'];
    updateAsteriskStatus(asterisk);
    if (
      ignoreDataOnChart[currentvalue[data.name || 'label']] &&
      Number(
        currentvalue.value[data.y || 'pct'].toString().replace(/%/g, '')
      ) === 0
    ) {
      return accumulator;
    }

    if (removeLabel[name]) {
      return accumulator;
    }
    const colorConfig =
      data.coloreConfig && data.coloreConfig[currentvalue.label]
        ? data.coloreConfig[currentvalue.label].color
        : '';
    const colorValue = data.colorValue
      ? calculateColor(
          Number(
            currentvalue.value[data.y || 'pct'].toString().replace(/%/g, '')
          ),
          data.colorValue,
          data.maxColor,
          data.minColor
        )
      : colorConfig;
    accumulator.push({
      name,
      y: Number(
        currentvalue.value[data.y || 'pct'].toString().replace(/%/g, '')
      ),
      dataLabels: {
        enabled: true,
        format: asterisk + currentvalue.value[data.y || 'pct'],
      },
      color: colorValue,
      value: {
        index: currentvalue.value.index,
        sample: numberWithCommas(currentvalue.value.sample),
        weighted: numberWithCommas(currentvalue.value.weighted),
        pct: Math.round(Number(currentvalue.value.pct.replace(/%/g, ''))),
        asterisk,
      },
    });
    return accumulator;
  }, []);

export const SEGMENTATION_DROPDOWN = [
  { key: 'Food Lifestyle', dataKey: 'Food Lifestyle' },
  { key: 'Health And Well Being', dataKey: 'Health And Well Being' },
  { key: 'Retail Shopping', dataKey: 'Retail Shopping' },
  { key: 'Mobile World', dataKey: 'Mobile World' },
  { key: 'Mobility Adoption', datakey: 'Mobility Adoption' },
  { key: 'Technology Adoption', dataKey: 'Technology Adoption' },
  { key: 'Consumer Privacy', dataKey: 'Consumer Privacy' },
  { key: 'Economic Outlook', dataKey: 'Economic Outlook' },
  { key: 'Auto-motives', dataKey: 'Auto-motives' },
  { key: 'TV Product Placement', dataKey: 'TV Product Placement' },
  { key: 'Movie Product Placement', dataKey: 'Movie Product Placement' },
  { key: 'Civic Engagement', dataKey: 'Civic Engagement' },
  { key: 'Fashion & Style', dataKey: 'Fashion & Style' },
  { key: 'Savings & Investing', dataKey: 'Savings & Investing' },
  { key: 'Consumer Innovators', dataKey: 'Consumer Innovators' },
  { key: 'Green Aware', dataKey: 'Green Aware' },
  { key: 'Health and Well-Being', dataKey: 'Health and Well-Being' },
  {
    key: 'Hispanic Acculturation Primary',
    dataKey: 'Hispanic Acculturation Primary',
  },
  {
    key: 'Hispanic Acculturation Transitional',
    dataKey: 'Hispanic Acculturation Transitional',
  },
  { key: 'Online Shoppers', dataKey: 'Online Shoppers' },
  { key: 'Leisure Styles', dataKey: 'Leisure Styles' },
  { key: 'Media Attitude - TV', dataKey: 'Media Attitude - TV' },
  { key: 'Media Attitude - Radio', dataKey: 'Media Attitude - Radio' },
  { key: 'Media Attitude - Magazines', dataKey: 'Media Attitude - Magazines' },
  {
    key: 'Media Attitude - Newspapers',
    dataKey: 'Media Attitude - Newspapers',
  },
  { key: 'Media Attitude - Internet', dataKey: 'Media Attitude - Internet' },
  { key: 'Media Attitude - Mobile', dataKey: 'Media Attitude - Mobile' },
  { key: 'Food and Lifestyle', dataKey: 'Food and Lifestyle' },
  { key: 'Political Personas', dataKey: 'Political Personas' },
];

const FOODLIFESTYLE = [
  {
    key: 'Convenience and Ease',
    value: `Want food that is fast, convenient, and easy to prepare and/or eat. They show little interest
  in cooking, healthy eating, or nutritional value. These eaters prefer picking up a prepared meal to
  spending time cooking at home.`,
  },
  {
    key: 'Reformed Traditionals',
    value: `Have come to realize that they should make healthier choices in food rather than letting
  convenience be the guiding force. They stay away from junk food, watch their fat intake, and always
  look for information about the food they buy.`,
  },
  {
    key: 'Variety on a Budget',
    value: `Are very busy and frequently eat on the run. They see frozen food as a convenient alternative
  to preparing meals with fresh ingredients. They are interested in gourmet food – as long as it fits
  into their budget.`,
  },
  {
    key: 'True Foodies',
    value: `Passionate about food and spend a lot of time cooking at home. They prefer fresh ingredients
  and organic food and consider themselves culinary experts. Variety is the spice of their life, and they
  love to try different cuisines.`,
  },
  {
    key: 'Weekend Cooks',
    value: `Have some interest in cooking, but are mostly sociable home chefs. When they can find time in their
  busy schedule, they love to cook for friends and family. For this group, healthy food is tasty food, though
  they do indulge their cravings.`,
  },
];

const HEALTHANDWELLBEING = [
  {
    key: 'The Invincibles',
    value: `Generally unconcerned about their health, they eat what they want and rarely get sick. They are
  younger and lead busy lives – they rely on fast food on the run and shun preventative health care measures.`,
  },
  {
    key: 'Weight Reformers',
    value: `Constantly struggling with healthy food choices to improve their diet and their health. They are
  always quick to try a new diet or weight-loss plan in their struggle to break bad food habits and are often
  trying to exercise more.`,
  },
  {
    key: 'Trusting Patients',
    value: `Rely on doctors and modern medicine as well as practicing a healthy lifestyle. They are older,
  and take an active role in managing their health, seeking out health information as well as purchasing
  fresh and natural ingredients.`,
  },
  {
    key: 'Healthy Holistics',
    value: `Committed to exercise, organic foods, and healthy choices while shopping and eating, which help
  them to stay healthy. They are active in their personal health management, trust holistic medicine, and
  like to cook nutritious meals.`,
  },
  {
    key: 'Image Shapers',
    value: `Looking good means being healthy; they embrace convenience in their healthy choices. They are
  brand-loyal, tend to be vegetarians, and like healthy pre-cooked and fast food options.`,
  },
];

const RETAILSHOPPING = [
  {
    key: 'Just the Essentials',
    value: `No-nonsense consumers who primarily purchase necessities; they know what they want and are not
  impulsive shoppers.`,
  },
  {
    key: 'Status Strivers',
    value: `Shopping is fun and recreational; they like to browse as much as buy, are willing to travel to
  stores, and spend the money and time to keep up with trends.`,
  },
  {
    key: 'Mall Maniacs',
    value: `Not just consumers, they are “try-sumers” who like to try new products, stores, and styles.
  They connect and interact with their preferred brands.`,
  },
  {
    key: 'Upscale Clicks and Bricks',
    value: `Knowledgeable consumers who buy in-store and online. They always research online first,
  shop around, and compare prices before buying.`,
  },
  {
    key: 'Virtual Shoppers',
    value: `Concerned with affordability and ease, they always go for the bargains. The internet helps
  them find discounts so they never pay full price.`,
  },
  {
    key: 'Original Traditionalists',
    value: `Loyal to their brands, stores, services, and products produced in the US. This group is
  knowledgeable and incorporates green practices regularly.`,
  },
];

const MOBILEWORLD = [
  {
    key: 'Mobile Professionals',
    value: `They use multiple features on their phones, which helps them keep up with their busy
  professional and personal lives. Members of this group are more likely to own a smartphone; in fact,
  their cell phone has become their all-in-one device for their communication and information needs.`,
  },
  {
    key: 'Mobirati',
    value: `This segment represents the mobile generation. They grew up with cell phones and cannot imagine
  life without them. Mobile devices are a central part of their everyday lives and are a part of nearly
  everything they do.`,
  },
  {
    key: 'Basic Planners',
    value: `These individuals are not into cell phones or the world of technology in general. They use
  their phone simply for the basics and see it as just another communications device.`,
  },
  {
    key: 'Social Connectors',
    value: `Communication is central in the life of a Social Connector. Their mobile phone is a bridge to
  their social world, allowing them to keep up to date with important friends, social events, news, and
  their favorite celebrities on social media.`,
  },
  {
    key: 'Pragmatic Adopters',
    value: `This group came to mobile devices later in life. Cell phones are playing an increasingly important
  role in their lives, but they still focus heavily on the device’s primary functions as opposed to its
  advanced features.`,
  },
  {
    key: 'Do Not Own Cell Phone',
    value: '',
  },
];

const MOBILITYADOPTION = [
  {
    key: 'Pacesetters',
    value: `Having grown up with them, mobile devices are an everyday part of life for this group and are
    integrated into everything they do. This group is much more likely to have multiple mobile devices on them,
    which makes them less reliant on any one device. Younger than the other groups, they are always connected to
    the internet, whether it’s for social connections, media consumption, shopping, etc.`,
  },
  {
    key: 'Socialites',
    value: `This group uses their mobile devices to stay connected with friends and interact socially with their world.
    Smartphones keep them up to date with what’s going on in their world, important news, and what their friends are
    doing. Texting, posting photos and videos, and social network activities help this group expand their overall social
    footprint.`,
  },
  {
    key: 'Knowledge Seekers',
    value: `Easy internet access has increased this group’s desire to search for all kinds of information, and their
    mobile devices are where they go for the information they seek. They believe their smartphones should work hard for
    them, and they tend to use all kinds of phone features to get the most out of their devices. This group is open to
    shopping online, but always looking for deals when they do.`,
  },
  {
    key: 'Moderates',
    value: `This group has been a little slower to adopt mobile devices and are generally less passionate about the
    internet and technology then others mobile users. While many have taken the leap into the world of smartphones,
    they focus primarily on basic features like email, text and the camera.`,
  },
  {
    key: 'Functionalists',
    value: `These individuals are not very interested in mobile devices, and might avoid them altogether if they can.
    They use their cell phones primarily for the basics and, although less tech-savvy then others, they are perfectly
    fine managing without the technology that others find essential. Overall, they tend to have more conservative
    outlooks and are generally older.`,
  },
  {
    key: 'Unclassified',
    value: '',
  },
];

const TECHNOLOGYADOPTION = [
  {
    key: 'Wizards',
    value: `Technology plays an important and broad role in their life. They cannot live without the internet
  or imagine life without new electronic gadgets. Wizards are enthusiastic and adventurous users of new
  technology. This group’s hunger for new technology fuels a future for potential new features, benefits,
  and devices.`,
  },
  {
    key: 'Journeymen',
    value: `They have become skilled users of new technology, and are confident with and knowledgeable about
  it. They are willing to experiment with new features, benefits, and devices. While cutting-edge gadgets
  may help them organize their busy lives, new technology is not always their top priority.`,
  },
  {
    key: 'Apprentices',
    value: `This group takes advantage of technology, using the Internet often to get needed information. New
  gadgets enhance their lives to a large extent, but there is still room for them to expand. Apprentices are
  willing to incorporate new tech into their lives, but are price-sensitive and often make purchase decisions
  based on this.`,
  },
  {
    key: 'Novices',
    value: `They are disconnected from emerging technology and resistant to adopting a new technology-focused
  life. Novices may embrace new digital products and services if they are simple and easy to use. They do
  not understand what kinds of opportunities and experiences technology can provide them and thus limit their
  engagement.`,
  },
];

const CONSUMERPRIVACY = [
  {
    key: 'Informed and At Ease',
    value: `Protect their privacy information online and off. Try to be as knowledgeable as possible, but
  concerns about privacy may limit participation.`,
  },
  {
    key: 'Cautious and Controlled',
    value: `Their digital footprint has not yet been affected by their personal info online and off. They
  will share info but like to remain in control of it.`,
  },
  {
    key: 'Impacted and Engaged',
    value: `Have been “injured” by online information about them. They try to monitor and control their
  online (and offline) presences.`,
  },
  {
    key: 'Digital and Unconcerned',
    value: `Having their personal information online and off has not yet been a threat, but they need to
  be educated on the risks of sharing info online.`,
  },
  {
    key: 'Trust but Verify',
    value: `Understand the utility of personal info online to improve product and service preferences while
  remaining aware of the consequences of identity theft.`,
  },
  {
    key: 'Connected and Confident',
    value: `Willing to provide and share personal info online and off, yet understand how to control this
  data and are proactive about using this knowledge.`,
  },
];

const ECONOMICOUTLOOK = [
  {
    key: 'Facing Challenges',
    value: `Their consumer confidence and propensity to purchase everything is low. Their financial situation
  is worse than it was a year ago, and they are neither hopeful about their personal fiscal future nor that
  of the American economy.`,
  },
  {
    key: 'Financial Nesters',
    value: `They are trying to maintain their lifestyle with a “business as usual” outlook, but are aware of
  the changes in the economy. They don’t expect either to improve any time soon, but continue to spend and
  plan for their anticipated retirement.`,
  },
  {
    key: 'Economically Indifferent',
    value: `This group, who generally has a modest financial situation, are out of the mainstream; they are
  economically indifferent to fiscal changes. They do not have any sense that the economy is changing for
  better or worse.`,
  },
  {
    key: 'Fiscally Fit',
    value: `More flexible and adaptive to changes in the market than others, they are well-positioned to
  weather any economic downturns. They are not risk-takers, but are optimistic about the future of the
  American economy as well as their own fiscal health.`,
  },
  {
    key: 'Confident Spenders',
    value: `Truly confident about their current fiscal situation, this group is financially secure and willing
  to take investment risks. Their purchase behavior, if it has changed at all, leans toward spending more on
  big- and medium-ticket items.`,
  },
];

const AUTOMOTIVES = [
  {
    key: 'Main Streets',
    value: `Main Streets’ driving behaviors are actually quite pedestrian. From their viewpoint, a car is
  simply a method of getting from Point A to Point B and not much more. They are purpose-driven drivers;
  to them, a car is just a car.`,
  },
  {
    key: 'Boulevards',
    value: `Like new cars with luxury features and all the bells and whistles. They get enjoyment from driving,
  love their American-made vehicles, and take pride in their car, seeing it as a reflection of their lifestyle
  and their image.`,
  },
  {
    key: 'Rough Terrains',
    value: `Love speed and performance and are less concerned with safety features. They know about the latest
  advances in auto technology and are exuberant about power. They tend to favor SUVs, which match their active
  lifestyles.`,
  },
  {
    key: 'City Streets',
    value: `This group likes to change cars frequently; their vehicle is part of their identity. They choose their
  vehicle for its status and image, rather than any practical qualities or performance. They also use their car
  for both work and pleasure.`,
  },
  {
    key: 'Cul-de-Sacs',
    value: `Practical drivers who say that function and comfort are the true sources of value in a car. They tend
  to choose vehicles for practical qualities rather than performance. You can often find them taking long car
  trips on their vacations.`,
  },
];

const TVPRODUCTPLACEMENT = [
  {
    key: 'Emulators',
    value: `This segment has the strongest connection to branded goods or services placed into the context of
  television programming. Viewers are engaged and aware of product placement, and the recognition allows this
  segment to remember, try, and buy brands they have seen in a show.`,
  },
  {
    key: 'Noticers',
    value: `Noticers are devoted to TV and notice branded goods or services that are placed in television shows.
  However, they are less likely than the average viewer to remember the product later and do not feel that
  placement in the television program affects their shopping behavior.`,
  },
  {
    key: 'Indifferents',
    value: `Indifferents have neutral attitudes toward TV product placement. Members of this segment appear to
  be disengaged when it comes to noticing or remembering products placed in television shows.`,
  },
  {
    key: 'Rejecters',
    value: `TV product placement has the opposite of the intended effect on this segment of viewers. Rejecters
  actually have negative attitudes toward branded goods or services that are placed into the context of
  television shows and may be less likely to buy them.`,
  },
];

const MOVIEPRODUCTPLACEMENT = [
  {
    key: 'Emulators',
    value: `This segment has the strongest connection to branded goods or services placed into the context of
  movies. They are engaged and aware of product placement, and the recognition allows this segment to remember,
  try, and buy brands they have seen in a movie.`,
  },
  {
    key: 'Noticers',
    value: `Noticers notice branded goods and services that are placed in movies. While they may be more likely
  to remember the placed products later, they do not feel that placement affects their shopping behavior.`,
  },
  {
    key: 'Indifferents',
    value: `This segment has mostly neutral attitudes toward movie product placement. Indifferents are disengaged
  for most product placement attributes but are slightly more likely to be influenced to buy when a character
  actually uses a product.`,
  },
  {
    key: 'Rejecters',
    value: `Movie product placement has the opposite of the intended effect on this segment of viewers. Rejecters
  actually have negative attitudes toward branded goods or services that are placed into the context of movies
  and may be less likely to buy them.`,
  },
];

const FOODATTITUDES = [
  {
    key: 'Food-to-Go',
    value: `Do not cook frequently. Often eat meals on the run. Do not have much interest in cooking. 
    Often indulge cravings for sweets. Prefer picking up quick meals to cooking meals.`,
  },
  {
    key: 'Home Cooking Virtuosos',
    value: `During the week, cook frequently. If a food item is on sale, buy multiple units to stock up. Buy not 
      only name brand food items. If generic brands are on sale, will purchase them over the normal name brand. 
      Have interest in cooking. Do not prefer picking up quick meals to cooking. When they find a food product 
      that they like, they typically recommend it to people they know.`,
  },
  {
    key: 'Cooking-Up an Image',
    value: `Do not stock up on multiple units of food, even if food item is on sale. Only buy food items that 
      are name brand, not generic brand. Will not purchase generic brand over the normal name brand, even if 
      generic brand is on sale. Do not indulge cravings for sweets. Do not like picking up quick meals.`,
  },
];

const HEALTHATTITUDES = [
  {
    key: 'Generic Traditionalists',
    value: `Find generic medications to be as effective as brand-name drugs. If the drug brand works, they stick 
      with it. Do not feel that herbal supplements are particularly effective. Do not favor alternative medicine 
      to traditional medical practices. In general, do not think that newer brands work better than old ones.`,
  },
  {
    key: 'Alternatives',
    value: `Prefer alternative medicine to traditional medical practices. Disagree with the statement  “I don’t feel 
      herbal supplements are particularly effective.”  Do not favor popular brand-name drugs. Do not consider 
      themselves the first to try the most advanced medicines.  Do not agree that newer drug brands necessarily 
      work better than older brands.`,
  },
  {
    key: 'Brand-Name Traditionalists',
    value: `Often first to try the most advanced medicine. Prefer popular brand-name drugs, even if they cost more. 
      In general, feel that newer drug brands work better than older ones.  If the drug brand works, 
      they stick with it.`,
  },
];

const BUYINGSTYLE = [
  {
    key: 'Penny-Pinchers',
    value: `Nuances of quality and desirability are not paramount to these consumers, who judge all purchases 
    by a single criterion: cost (the lower the better). Brand loyalty is less important than a “cents-off” coupon,
    and they express little interest in technology, nutrition or the environment, unless it will save them money.`,
  },
  {
    key: 'Conscientious Consumers',
    value: `These consumers know what they’re paying for and shop for bargains, but cost is only one of the factors
     they consider when shopping. Buying American products and environmentally safe products also matter.
    They are conscious of quality, loyal to their brands and highly unlikely to try new products or make 
    impulse purchases.`,
  },
  {
    key: 'Buyers of The Best',
    value: `Low price is not the objective to consumers in this segment; it’s quality that matters most.
     They are careful to buy the best, and brand loyalty trumps all other considerations in their purchases.
     They favor environmentally safe products, are extremely comfortable with new technology, 
    and always check the ingredients and nutritional content of food products they buy.`,
  },
  {
    key: 'Habitualized Havers',
    value: `These consumers find comfort in tradition, even when it’s just their own – they buy what they have
     always bought and see little reason to change. They are brand-loyal, but only in the sense that once they’ve
      found a brand they are comfortable with, they stop looking.`,
  },
  {
    key: 'Swayable Shopaholics',
    value: `They shop for no other reason than that they want to; price, quality, brand, and ”Made in America”—nothing
     matters so much to them as the emotional payoff from a simple act of buying. Impulse buyers, these consumers are
      willing to pay extra for image-enhancing products, and easily switch brands for the sake of novelty or variety.`,
  },
];

const MOBILEATTITUDES = [
  {
    key: 'Disconnected',
    value:
      'Respondents who did not report having a working cellular/mobile phone are assigned to this segment.',
  },
  {
    key: 'Mobile If I Must',
    value: `The members of this segment believe that cell phones are too complicated these days, and they are 
      likely to keep a household (landline) telephone, no matter how much cell phone service improves. They 
      are least likely to think of their cell phones as a source of entertainment or an extension of their 
      personality, to customize the look or sounds of their phones, or to use any advanced features of their phones.`,
  },
  {
    key: 'Mobile Minimalists',
    value: `The respondents in this segment understand how to use most of the features on their cell phones, 
      but do not think of their cell phones as a source of entertainment or an extension of their personality. 
      They are unlikely to customize their phones or use any advanced applications or features. 
      The most commonly used cell phone features by members of this segment include phone calls, 
      text messaging, voice mail, speakerphone, camera, calendar/organizer, and address book.`,
  },
  {
    key: 'Mobile App-Happy',
    value: `The members of this segment carry their cell phones everywhere they go, often use their cell 
      phones to make calls from home, and believe that text messaging is an important part of their daily lives. 
      They understand how to use most of the features, and believe that it is very convenient when mobile 
      devices can do everything.  Members of this segment regard their mobile phones as an extension of 
      their personality and a source of entertainment. They customize their phones, and use such advanced 
      features as browsers (including search, visiting news, entertainment, sports, and other web sites, 
      looking up for directions and maps), voting applications, “alert” services, video and TV, podcasts, 
      FM radio, camera, MP3 player, games, Bluetooth, GPS navigation, and others. They, however, are very 
      unlikely to be open to special offers like advertising in exchange for services or lower fees, and 
      are not responsive to advertising sent with text messages.`,
  },
  {
    key: 'Mobile Ad & App-Happy',
    value: `The respondents in this segment understand how to use most of the features on their phones, 
      and regard their mobile phones as an extension of their personality and a source of entertainment. 
      They enjoy customizing the look and feature of their phones, and believe that text messaging is 
      important part of their daily lives. They are also more likely than members of other segments to be 
      open to special offers like receiving advertising on their phones in exchange for a lower monthly fee 
      or services, and paying a subscription fee to watch live TV. Unlike members of Mobile Minimalists, 
      they are less likely to use phone and voice mail. Yet they are very likely to use all other advanced 
      features (FM radio, camera, video and MP3 player, Bluetooth, calendar, GPS/navigation, address 
      book, games, ringtones, mobile browser, search, and email) and services (IM, text alerts, voting, 
      watching TV, etc.). They are more likely than members of other segments to look at advertisements sent 
      with text messages, and to respond with a text message to an advertisement.`,
  },
];

const TECHNOLOGYATTITUDES = [
  {
    key: 'Techno-Phobes',
    value: `Members of this group have an explicitly negative opinion about modern technology and electronics: 
      they find technology confusing, and believe that it has little impact on their daily lives. As a result, 
      members of this group are not interested in reading about technology products, unlikely to use advanced 
      gadgets and applications, and are least likely to shop for electronics.`,
  },
  {
    key: 'Techno-Laggards',
    value: `Members of this group have no opinion about technology, and generally are not interested in advanced 
      electronics or applications. Unlike Techno-Phobes, however, Laggards are one step ahead. They do not find 
      computers intimidating, are comfortable with common electronics, and may access Internet. Their use of 
      Internet, however, is limited to routine things, such as checking e-mail, searching for recipes and 
      medical information, or shopping, and they are more likely to access via a dial-up connection.`,
  },
  {
    key: 'Tech-Sploiters',
    value: `Members of this group have no interest in technology or electronics beyond simply using them in everyday 
      life and at work as means for productivity and comfort. They are comfortable with computers, and likely to 
      own and use laptops, digital cameras and camcorders, DVRs, and PDAs. They use the Internet for more than 
      banking, paying bills, and planning travel, and go as far as to participate in online dating, search for 
      information, and shop online. They are likely to access web via broadband connection, and send text messages 
      on their cell phones. However, they are not likely to be involved in making shopping decisions or carrying 
      out actual purchases of new electronics.`,
  },
  {
    key: 'Techno-Gamers',
    value: `The sole purpose of technology and electronics for members of this segment is entertainment. 
      They are not interested in technology in general, but always ready to share their advice with others, 
      and are often among the first to try new gadgets. Most favored cell phone features in this segment are MP3 
      and video players, games, and web browsing. They are huge fans of electronic, computer, and video games. 
      They access web through broadband connection and from their cell phones. Online, they are more likely to 
      chat, participate in dating services, play online games, access gambling sites, download music and podcasts, 
      read and write blogs, watch videos, and listen to radio. This segment has a high percentage of readers 
      of magazines in the “Computer/Video Games” category.`,
  },
  {
    key: 'Tech-Thusiasts',
    value: `Members of this group are truly interested in new technology and electronics, and are fascinated 
      about developments in this area. They appreciate good quality electronics, and are willing to pay more 
      for those items. Their interests are mainly in computers and general science and technology, and, as a 
      result, this segment has a high percentage of readers of magazines in the “PC” and “Science/Technology” 
      categories. They are very likely to use advanced electronics and gadgets, including laptops, PDAs, digital 
      cameras and camcorders, and very comfortable with using various computer peripherals and advanced software. 
      Members of this segment access Internet exclusively through broadband connection and from their mobile 
      phones. They are very active online, and are involved in all kinds of activities, from shopping to searching 
      for information to downloading music and watching videos online. Members of this segment are also actively 
      involved in making shopping decisions and carrying out actual purchases of electronics and applications.`,
  },
  {
    key: 'Tech-Splorers',
    value: `This group tops the hierarchy of technology users. Members of this segment are genuinely fascinated 
      about technology. They are also among those to first try new gadgets and applications. And, they are always 
      ready to share their experience and advice with others. They are heavy users of advanced technologies, 
      electronics, and applications in all areas, including entertainment, communications, and business/productivity. 
      This segment has the highest percentage of Technology Innovators, and readers of magazines in the “PC”, 
      “Science/Technology”, and “Computer/Video Games” categories. Members of this segment are also actively 
      involved in making shopping decisions and carrying out actual purchases of new electronics and applications.`,
  },
];

const GENERALATTITUDES = [
  {
    key: 'Faith & Family',
    value: `The interests of consumers in this segment do not venture far beyond their families and their faith.
     Spending time with family is a top priority, they try to eat dinner with their families almost every night
      and believe that marriage should be legal only between a man and a woman. They consider themselves to be 
      spiritual, attend religious services regularly and say that prayer is a part of their daily lives. Members
       of this segment show little interest in environmental causes, the arts, or foreign cultures.`,
  },
  {
    key: 'Status Seekers',
    value: `For members of this segment, family and faith take a distant second place to social or career advancement.
     Their lifestyles are admittedly meant to impress others and they enjoy being the center of attention.
     Status Seekers relish the excitement associated with risk-taking and show little concern for the environment.
     Any interest they may have in the arts or foreign cultures is directly related to their drive for what they
     define as success.`,
  },
  {
    key: 'Knowledgeable Nesters',
    value: `Home is the primary focus for members of this segment, who strive to have dinner with their families
     almost every night. Consumers in this segment value order but seek variety in their everyday lives.
     They are environmentally conscious and genuinely interested in the arts and foreign cultures. Nesters find it
     important to keep their homes neat and organized and enjoy showing their homes to guests.`,
  },
  {
    key: 'Culturally Connected',
    value: `By choice or by life stage, respondents in this segment focus less on family than other consumer
     segments and more on the things of this world. They are environmentally conscious, interested in the fine arts
     and in learning about foreign cultures. They show little interest in religious matters and are very liberal
     when it comes to opinions about marriage equality.`,
  },
];

const FINANCIALATTITUDESMARKETINVOLVEMENTSAVINGS = [
  {
    key: 'Financially Uninvolved',
    value: `Not interested in finance or financial news. Agree with the statement that they are “better off having 
      what they want now.” Save only for specific purposes. Do not find ups and downs of the market exciting. 
      Do not favor low risk investments.`,
  },
  {
    key: 'Savers First',
    value: `Not interested in finance or financial news and publications. Prefer to keep money in low risk 
      investments. Think about tomorrow. Do not like taking risks, even for a chance at a high return. Save not only 
      for specific purposes. Find investing in stock market too risky.`,
  },
  {
    key: 'Money Game Players',
    value: `Regularly read financial news or publications. Do not prefer low risk investments. Think about tomorrow. 
      Save not only for specific purposes. Do not find investing in stock market risky. Less likely to deal with 
      finances as their parents did with theirs.`,
  },
  {
    key: 'Money Game Spectators',
    value: `Agree with the statement that they are “better off having what they want now.” Like to take risks for 
      the chance of higher return. Save only for specific purposes. Find ups and downs of financial market exciting. 
      Find investing in stock market too risky. Likely to deal with finances as their parents did with theirs.`,
  },
];

const AUTOMOTIVEATTITUDESIDEALS = [
  {
    key: 'Car =Basic and Functional',
    value: `Prefer vehicles that have both the comforts of a car and capabilities of a truck. Do not care who makes 
      the car or in what country it was produced. Do not purchase expensive models with luxury appointments and 
      options. Rebates and incentives have no influence on their vehicle purchase decisions.`,
  },
  {
    key: 'Car =Transportation only',
    value: `It matters to them who made the car or in which country it was produced. Think of vehicles as basic 
      transportation. Want cheapest and easiest to maintain vehicle they can find. Not interested in vehicle with 
      bold or innovative design. Have no commitment to support environment when purchasing vehicles.`,
  },
  {
    key: 'Car =Luxury and Style',
    value: `It does not matter to them who made the vehicle or in what country it was produced. In choice of the 
      vehicle, commitment to support environment does not play important role. First consideration in buying the 
      vehicle is look at exterior styling. Generally purchase most expensive models with luxury appointments and 
      other options.`,
  },
  {
    key: 'Car =Green and Suitable',
    value: `It matters to them who made the car or in which country it was produced. Try to buy vehicles that 
      reflect their commitment to supporting environment. In general, not interested in most expensive models. 
      Important to have vehicle that accommodates their busy lifestyle.`,
  },
  {
    key: 'Car =Green and Trendy',
    value: `Try to buy vehicles that reflect their commitment to support environment. Seek vehicles with bold and 
      innovative design that stand out on the road. Express interest in purchasing most expensive models with 
      luxury appointments and other options. Rebates and incentives strongly influence their purchase decisions.`,
  },
];

const CIVICPOLITICALENGAGEMENT = [
  {
    key: 'Passive Civics',
    value:
      'Members of this segment are least likely to be engaged in civic or political activities.',
  },
  {
    key: 'Strictly Voters',
    value: `Members tend to vote in local, state, or federal elections, but least likely to be engaged in other 
      civic or political activities.`,
  },
  {
    key: 'Vote and Sign',
    value: `Those likely to have voted in local, state, or federal elections, signed petitions, 
      and contacted politicians.`,
  },
  {
    key: 'Civic Advocates',
    value: `Members of this segment are likely to have written something that was published, written an article 
      for a magazine or newspaper, contacted media such as newspapers, radio, or TV shows, and/or made a speech.`,
  },
  {
    key: 'Local Participants',
    value: `Those belonging to this segment are likely to have voted in federal, state, or local elections, 
      served on a committee for some local organization, served as an officer for some club or organization, 
      and/or engaged in fundraising.`,
  },
  {
    key: 'Political Activists',
    value: `Respondents in this segment are likely to have voted in federal, state, or local elections, contacted 
      politicians, attended a political rally, speech, or organized protest of any kind, attended a public meeting on 
      town or school affairs, held or ran for political office, worked for political party, signed a petition, 
      and/or been an active member of group that tries to influence public policy or government.`,
  },
];

const GREENATTITUDESBEHAVIORS = [
  {
    key: 'UnGreen',
    value: `The responses given by the members of this segment do not indicate that environmental issues are a 
      priority for them. They are not willing to pay more or give up convenience in return for environmentally 
      safe products. They do not eat organic food, nor partake in environmentally motivated behavior.`,
  },
  {
    key: 'Green at the Supermarket',
    value: `Members of this group do not indicate that environmental issues are a priority for them. However, 
      they are willing to pay more and/or give up convenience in return for environmentally safe products, most 
      likely because of their own health concerns. They regularly eat organic foods. They do not partake in 
      environmentally motivated behavior.`,
  },
  {
    key: 'Green in Theory',
    value: `The responses given by the members of this segment indicate that environmental issues are a priority 
      for them. They are willing to pay more money and/or give up convenience in return for environmentally 
      safe products. They, however, do not partake in environmentally motivated behavior.`,
  },
  {
    key: 'Green But Only If',
    value: `Members of this group may give responses indicating that they prioritize environmental issues. 
      However, they are unwilling to pay more and/or give up convenience in return for environmentally safe 
      products, although they do partake in environmentally motivated behavior.`,
  },
  {
    key: 'Green at Their Best',
    value: `Members of this group give responses that indicate that environmental issues are a priority for them. 
    They are willing to pay more money and/or give up convenience in return for environmentally safe products. 
    Additionally, they partake in everyday environmentally motivated behavior.`,
  },
  {
    key: 'Green Advocates',
    value: `Members of this segment indicate that environmental issues are a priority for them. They are willing 
      to pay more money, and/or give up convenience in return for environmentally safe products.  Furthermore, 
      they definitely partake in environmentally motivated behavior as well as participate in environmental
      causes/groups.
    `,
  },
];

const CIVICENGAGEMENT = [
  {
    key: 'Political Activists',
    value: `Deeply committed to and involved in the political process,
     these consumers index exceptionally high across a full range of political activities.
      Respondents in this segment are likely to have voted in federal, state, or local elections, 
      contacted politicians, attended a political rally, speech, or organized protest of any kind, 
      attended a public meeting on town or school affairs, held or ran for political office, worked 
      for political party, signed a petition, and/or been an active member of group that tries to 
      influence public policy or government.`,
  },
  {
    key: 'Local Participants',
    value: `These citizens show a high level of interaction with other people in their communities.
   They serve on local committees, as officers of local clubs and organizations, and engage in public
   fundraising at higher rates.`,
  },
  {
    key: 'Civic Advocates',
    value: `Members of this segment want their voices heard. They publish books, write articles for magazines
   and newspapers, deliver speeches and use all forms of media, including live radio and TV programs,
  to promote their views and opinions.`,
  },
  {
    key: 'Vote & Sign',
    value: `Adults in this segment tend to limit their public or civic activities to voting and signing petitions,
   contacting politicians, and to shy away from more active forms of political involvement.`,
  },
  {
    key: 'Strictly Voters',
    value: `They vote in local, state and federal elections, but are otherwise uninvolved in the political process.`,
  },
  {
    key: 'Passive Civics',
    value: `Adults in this segment do not vote, and do not involve themselves in any way in political activities.`,
  },
];

const FASHIONSTYLE = [
  {
    key: 'Function Over Fashion',
    value: `Members of this segment are indifferent to fashion and style and give it little thought.
     They are replacement rather than impulse buyers, purchasing new clothing items and shoes only when
     they have to and never spend beyond what has been budgeted. Classic styles and new fashions are all
     the same to these consumers, who feel no loyalty to specific brands and have little interest in keeping
    up with style trends.`,
  },
  {
    key: 'Mainstream Fashion',
    value: `Members of this segment are driven more by comfort and tried-and-true fashion sense than they are by popular
     trends. They are not particularly brand loyal and do not try to impress others with either classic or trendy brand
     labels. They do not follow fashion trends in magazines, and apparel endorsed by celebrities or from high-profile
     fashion designers do not necessarily appeal to them.`,
  },
  {
    key: 'Fashionable on a Budget',
    value: `These consumers believe in the power of fashion but are careful in how they indulge their appetite for
     designer labels and trendy styles. Their brand loyalty is limited to just a few lines, but brands are important
      factors in their apparel choices, especially those from high profile designers or carrying celebrity endorsements.
     They always buy new clothes for each new season and admit to wanting to impress other people with their
    style sense, but they are also budget-driven and do not like to overspend.`,
  },
  {
    key: 'Fashion First',
    value: `These consumers are the fashion marketer’s dream: they wear designer brands to impress other people,
     consider themselves to be trend setters as well as trend followers and prefer high-style fashion designers
     and products endorsed by celebrities. They rely on magazines to keep up to date with latest trends and styles,
     are not necessarily loyal to their favorite brands, and are not afraid to go over budget on what they consider
    to be necessities.`,
  },
];

const SAVINGANDINVESTING = [
  {
    key: 'Financially Uninvolved',
    value: `These consumers focus on the present; they want what they want when they want it. They have little interest
     in things financial, even those that touch them personally. “Long-term Savings” is an abstract concept to them,
      and their avoidance to risk comes more from a lack of interest, among other things, than from a fear of loss.`,
  },
  {
    key: 'Savers First',
    value: `Members of this segment are enthusiastic about their savings, but highly intolerant of risking them for
     a greater return. “Savings” is an important factor for their futures, and as much an immediate necessity as food 
     and shelter. They have little interest in financial news and prefer to keep their money in low risk investments.`,
  },
  {
    key: 'Money Game Players',
    value: `These consumers want to have as much control over their investments as possible yet are willing to tolerate 
    market risk for a higher return. They follow developments in the financial world regularly, especially in the media,
     and are highly focused on the future.`,
  },
  {
    key: 'Money Game Spectators',
    value: `These consumers feed off the excitement of the market’s ups and downs but can’t take a chance on getting
     hurt themselves. Somewhat passive when it comes to long-term market investing, they are oriented more to the 
     present than to the future, they mostly save only for special purposes.`,
  },
];
const CONSUMERINNOVATORS = [
  {
    key: 'Food Innovators',
    value: `Food and the kitchen environment`,
  },
  {
    key: 'Home Appliance Innovators',
    value: `Home environment`,
  },
  {
    key: 'Electronic Innovators',
    value: `Electronics`,
  },
  {
    key: 'Leisure Innovators',
    value: `Leisure activities`,
  },
  {
    key: 'Financial Innovators',
    value: `Financial products and services`,
  },
  {
    key: 'Personal Care/Health Innovators',
    value: `Personal health and health care`,
  },
  {
    key: 'Super Innovators',
    value: `Three or more of the above`,
  },
];

const GREENAWARE = [
  {
    key: 'Behavioral Greens',
    value: `Behavioral Greens both think and act green. They have negative attitudes toward products that pollute,
     and they incorporate green practices on a regular basis.`,
  },
  {
    key: 'Think Greens',
    value: `Consumers in the Think Greens group think green but do not necessarily follow through on those beliefs
     with green actions. They are well-intentioned but will not go too far out of their way to behave green.`,
  },
  {
    key: 'Potential Greens',
    value: `Potential Greens neither behave nor think along particularly environmentally conscious lines;
     they remain on the fence about key green issues.`,
  },
  {
    key: 'True Browns',
    value: `Not environmentally conscientious at all, True Browns may, in fact, have negative attitudes about the 
    environment and the green movement.`,
  },
];

const MRIHEALTHANDWELLBEING = [
  {
    key: 'The Invincibles',
    value: `Generally unconcerned about their health, they eat what they want and rarely get sick. They are younger
     and lead busy lives - they rely on fast food on the run and shun preventative health care measures.`,
  },
  {
    key: 'Weight Reformers',
    value: `Constantly struggling with healthy food choices to improve their diet and their health. They are always
     quick to try a new diet or weight-loss plan in their struggle to break bad food habits and are often trying to 
     exercise more.`,
  },
  {
    key: 'Trusting Patients',
    value: `Rely on doctors and modern medicine as well as practicing a healthy lifestyle. They are older and take an
     active role in managing their health, seeking out health information as well as purchasing fresh and natural
      ingredients.`,
  },
  {
    key: 'Image Shapers',
    value: `Looking good means being healthy; they embrace convenience in their healthy choices. They are brand-loyal,
     tend to be vegetarians, and like healthy pre-cooked and fast-food options.`,
  },
  {
    key: 'Healthy Holistics',
    value: `Committed to exercise, organic foods, and healthy choices while shopping and eating, 
    which help them to stay healthy.They are active in their personal health management, trust holistic medicine,
     and like to cook nutritious meals.`,
  },
];

const HISPANICACCULTURATIONPRIMARY = [
  {
    key: 'Integrated',
    value: `Have integrated both Hispanic and U.S. culture into their lives. Have strong ties to Hispanic culture and 
    U.S. culture.`,
  },
  {
    key: 'Assimilated',
    value: `Fully assimilated into U.S. culture over Hispanic culture.`,
  },
  {
    key: 'Separated',
    value: `Have strong ties to Hispanic cultural heritage and have not embraced U.S. cultural behaviors.`,
  },
  {
    key: 'Anomic',
    value: `Have not embraced U.S. culture norms and traditions and, in addition, have minimal association with 
    Hispanic cultural heritage.`,
  },
];

const HISPANICACCULTURATIONTRANSITIONAL = [
  {
    key: 'Mostly Integrated',
    value: `Have mostly integrated both cultures into their lives. Association with Hispanic culture
    is somewhat attenuated.`,
  },
  {
    key: 'Somewhat Integrated',
    value: `Strongly identify with Hispanic culture and embrace U.S. culture somewhat.`,
  },
  {
    key: 'Somewhat Assimilated',
    value: `Identify more strongly with U.S. culture and somewhat more weakly with Hispanic culture.`,
  },
  {
    key: 'Mostly Separated',
    value: `Moderate ties to Hispanic culture and mostly weak ties to U.S. culture.`,
  },
];

const ONLINESHOPPERS = [
  {
    key: 'Offline-Only Shoppers',
    value: `Consumers in this segment do not have Internet access`,
  },
  {
    key: 'Traditional Consumers',
    value: `Although they have access to the Internet, consumers in this segment do not think that the Internet is a
     great way to buy products, and rarely shop online.`,
  },
  {
    key: 'Straightforward Shopper',
    value: `Consumers in this segment prefer purchasing things online for a fixed price, do not necessarily compare 
    prices across different web sites, do not shop for previously owned items, and do not read or share product reviews.`,
  },
  {
    key: 'Passionate Deal Seekers',
    value: `Consumers in this segment believe that the Internet is a great way to buy products. They typically read 
    reviews and compare prices across the websites before purchasing something online. They also share their opinions
     about products and services, and do not mind saving money by shopping in online auctions and purchasing previously
      used items.`,
  },
  {
    key: 'Active Quality Seekers',
    value: `Consumers in this segment believe that the Internet is a great way to buy products.
     Before purchasing online, they read reviews by other shoppers and compare prices across different websites.
      They, however, prefer to purchase products for a fixed price, and avoid buying previously used items.
       Unlike Passionate Deal Seekers,
      they do not share their opinions about products and shopping experiences.`,
  },
];

const MRIECONOMICOUTLOOK = [
  {
    key: 'Facing Challenges',
    value: `Their consumer confidence and propensity to purchase everything is low. Their financial situation is 
    worse than it was a year ago, and they are neither hopeful about their personal fiscal future nor that of the 
    American economy.`,
  },
  {
    key: 'Financial Nesters',
    value: `They are trying to maintain their lifestyle with a “business as usual” outlook but are aware of the
     changes in the economy. They don’t expect either to improve anytime soon but continue to spend and plan for
      their anticipated retirement.`,
  },
  {
    key: 'Economically Indifferent',
    value: `This group, who generally has a modest financial situation, are out of the mainstream; they are 
    economically indifferent to fiscal changes. They do not have any sense that the economy is changing for 
    better or worse.`,
  },
  {
    key: 'Fiscally Fit',
    value: `More flexible and adaptive to changes in the market than others, they are well-positioned to weather
     any economic downturns. They are not risk-takers but are optimistic about the future of the American economy
      as well as their own fiscal health.`,
  },
  {
    key: 'Confident Spenders',
    value: `Truly confident about their current fiscal situation, this group is financially secure and willing to 
    take investment risks. Their purchase behavior, if it has changed at all, leans toward spending more on big- and 
    medium-ticket items.`,
  },
];

const MRICONSUMERPRIVACY = [
  {
    key: 'Informed and At Ease',
    value: `Protect their privacy information online and off. Try to be as knowledgeable as possible but concerns
     about privacy may limit participation.`,
  },
  {
    key: 'Impacted and Engaged',
    value: `Have been “injured” by online information about them. They try to monitor and control their online 
    (and offline) presences.`,
  },
  {
    key: 'Cautious and Controlled',
    value: `Their digital footprint has not yet been affected by their personal info online and off. They will share 
    info but like to remain in control of it.`,
  },
  {
    key: 'Digital and Unconcerned',
    value: `Having their personal information online and off has not yet been a threat, but they need to be educated 
    on the risks of sharing info online.`,
  },
  {
    key: 'Trust but Verify',
    value: `Understand the utility of personal info online to improve product and service preferences while remaining
     aware of the consequences of identity theft.`,
  },
  {
    key: 'Connected and Confident',
    value: `Willing to provide and share personal information online and off yet understand how to control this data 
    and are proactive about using this knowledge.`,
  },
];

const MRIAUTOMOTIVES = [
  {
    key: 'Main Street Drivers',
    value: `Main Streets’ driving behaviors are actually quite pedestrian. From their viewpoint, a car is simply a
     method of getting from Point A to Point B and not much more. They are purpose-driven drivers; to them, a car
      is just a car.`,
  },
  {
    key: 'Auto Rough Terrain',
    value: `They love speed and performance and are less concerned with safety features. They know about the latest
     advances in auto technology and are exuberant about power. They tend to favor SUVs, which match their active 
     lifestyles.`,
  },
  {
    key: 'Practical Drivers',
    value: `Practical drivers who say that function and comfort are the true sources of value in a car. They tend to 
    choose vehicles for practical qualities rather than performance. You can often find them taking long car trips on 
    their vacations.`,
  },
  {
    key: 'Auto Luxury Lovers',
    value: `They like new cars with luxury features and all the bells and whistles. They get enjoyment from driving,
    love their American-made vehicles, and take pride in their car, seeing it as a reflection of their lifestyle and 
    their image.`,
  },
  {
    key: 'Status Cars',
    value: `This group likes to change cars frequently; their vehicle is part of their identity. They choose their 
    vehicle for its status and image, rather than any practical qualities or performance. They also use their car for
     both work and pleasure.`,
  },
];

const MRITECHNOLOGYADOPTION = [
  {
    key: 'Tech Wizards',
    value: `Technology plays an important and broad role in their life. They cannot live without the internet or 
    imagine life without new electronic gadgets. Wizards are enthusiastic and adventurous users of new technology. 
    This group’s hunger for new technology fuels a future for potential new features, benefits, and devices.`,
  },
  {
    key: 'Tech JourneymeN',
    value: `They have become skilled users of new technology and are confident with and knowledgeable about it.
     They are willing to experiment with new features, benefits, and devices. While cutting-edge gadgets may help
      them organize their busy lives, new technology is not always their top priority.`,
  },
  {
    key: 'Tech Apprentices',
    value: `This group takes advantage of technology, using the internet often to get needed information. New gadgets 
    enhance their lives to a large extent, but there is still room for them to expand. Apprentices are willing 
    to incorporate new tech into their lives but are price-sensitive and often make purchase decisions based on this.`,
  },
  {
    key: 'Tech Novices',
    value: `They are disconnected from emerging technology and resistant to adopting a new technology-focused life.
     Novices may embrace new digital products and services if they are simple and easy to use. They do not understand
      what kinds of opportunities and experiences technology can provide them and thus limit their engagement.`,
  },
];

const LESISURESTYLES = [
  {
    key: 'Sports Enthusiasts',
    value: `Baseball, basketball, football, Frisbee, soccer, softball, tennis and volleyball`,
  },
  {
    key: 'Puzzles & Games',
    value: `Backgammon, board games, crossword puzzles, electronic games (not TV), bingo, cards, word games,
     and trivia games`,
  },
  {
    key: 'Hunters & Fishers',
    value: `Archery, fishing (fresh water), fishing (salt water), hunting with a bow and arrow, 
    hunting with a handgun, hunting with a rifle, hunting with a shotgun, and target shooting`,
  },
  {
    key: 'Outdoor Speedsters',
    value: `Auto racing, power boating, jet skiing, motocross, motorcycling, roller-blading/inline skating,
     snowboarding, snow-mobiling, and water skiing`,
  },
  {
    key: 'Outdoor Adventurers',
    value: `Backpacking/hiking, canoeing/kayaking, horseback riding, jet skiing, rock climbing, sailing,
     scuba diving, skiing (cross country), skiing (downhill), snorkeling/skin diving, surfing/windsurfing,
      and whitewater rafting`,
  },
  {
    key: 'Cultured Nesters',
    value: `Attend other music performances, attend dance performances, concerts on radio, dining out, cooking for fun,
     entertain friends/relatives at home, go to live theatre, go to museums, and reading books`,
  },
  {
    key: 'Collectors',
    value: `Model making, coin collecting, figurine collecting, stamp collecting, sports trading card collecting, 
    electric trains, tropical fish`,
  },
  {
    key: 'Passives',
    value: `Model making, coin collecting, figurine collecting, stamp collecting, sports trading card collecting,
     electric trains, tropical fish`,
  },
];

const VACATIONPREFERENCES = [
  {
    key: 'Tour Groupies',
    value: `These vacationers enjoy the convenience and ease of guided tours and prefer packaged deals to independent
     travel. Whether by car, bus, plane or train, they want to see the sights – it’s why they travel.`,
  },
  {
    key: 'Kickin’ Back Vacationers',
    value: `Use their vacation time to rest and relax; the effort involved in taking a foreign trip, sightseeing or even
     going on a cruise is not for them. They prefer to travel by themselves or in small groups.`,
  },
  {
    key: 'Active Adventurers',
    value: `Choose vacation destinations that give them plenty to do. Frequent and independent travelers, 
    they like theme parks and sightseeing, physical exercise and outdoor recreation—especially while on vacation.`,
  },
  {
    key: 'Ever the Spring Breakers',
    value: `Still go for the fun, not the sights. They like guided or package tours for the convenience, 
    but don’t mind paying extra to fly with a favorite airline.`,
  },
];

const MEDIAATTITUDETV = [
  {
    key: 'Relaxation Only',
    value: `Consumers who value a given medium exclusively for its ability to entertain.`,
  },
  {
    key: 'Inspiration Only',
    value: `Users of a medium who primarily value the given medium as a source of good ideas and as a provider of
     information about new products, styles and trends.`,
  },
  {
    key: 'Information Only',
    value: `Consumers who value a given medium only for its ability to provide news or information.`,
  },
  {
    key: 'Relaxation & Inspiration',
    value: `Those consumers who value the medium as an entertainment resource and as a source for new ideas.`,
  },
  {
    key: 'Relaxation & Information',
    value: `Those media users who value the given medium as both an entertainment resource and as a source for news
     or information.`,
  },
  {
    key: 'Information & Inspiration',
    value: `Those users of a given medium who describe it as a good source for news or information and as a source of
     good ideas for products or trends.`,
  },
  {
    key: 'Three in One',
    value: `Those consumers who value a given medium for all three purposes—as an entertainment resource,
     as a source of news and information, and as a source of ideas or information about new trends and styles.`,
  },
  {
    key: 'No Specification',
    value: `Consumers who do not ascribe any of the three media evaluation criteria to the given medium.`,
  },
];

const MEDIAATTITUDERADIO = [
  {
    key: 'Relaxation Only',
    value: `Consumers who value a given medium exclusively for its ability to entertain.`,
  },
  {
    key: 'Inspiration Only',
    value: `Users of a medium who primarily value the given medium as a source of good ideas and as a provider
     of information about new products, styles and trends.`,
  },
  {
    key: 'Information Only',
    value: `Consumers who value a given medium only for its ability to provide news or information.`,
  },
  {
    key: 'Relaxation & Inspiration',
    value: `Those consumers who value the medium as an entertainment resource and as a source for new ideas.`,
  },
  {
    key: 'Relaxation & Information',
    value: `Those media users who value the given medium as both an entertainment resource and as a source for news
     or information.`,
  },
  {
    key: 'Information & Inspiration',
    value: `Those users of a given medium who describe it as a good source for news or information and as a source of
     good ideas for products or trends.`,
  },
  {
    key: 'Three in One',
    value: `Those consumers who value a given medium for all three purposes—as an entertainment resource, as a source of
     news and information, and as a source of ideas or information about new trends and styles.`,
  },
  {
    key: 'No Specification',
    value: `Consumers who do not ascribe any of the three media evaluation criteria to the given medium.`,
  },
];
const MEDIAATTITUDEMAGZZINES = [
  {
    key: 'Relaxation Only',
    value: `Consumers who value a given medium exclusively for its ability to entertain.`,
  },
  {
    key: 'Inspiration Only',
    value: `Users of a medium who primarily value the given medium as a source of good ideas and as a provider
     of information about new products, styles and trends.`,
  },
  {
    key: 'Information Only',
    value: `Consumers who value a given medium only for its ability to provide news or information.`,
  },
  {
    key: 'Relaxation & Inspiration',
    value: `Those consumers who value the medium as an entertainment resource and as a source for new ideas.`,
  },
  {
    key: 'Relaxation & Information',
    value: `Those media users who value the given medium as both an entertainment resource and as a source for news 
    or information.`,
  },
  {
    key: 'Information & Inspiration',
    value: `Those users of a given medium who describe it as a good source for news or information and as a source of 
    good ideas for products or trends.`,
  },
  {
    key: 'Three in One',
    value: `Those consumers who value a given medium for all three purposes—as an entertainment resource, as a source 
    of news and information, and as a source of ideas or information about new trends and styles.`,
  },
  {
    key: 'No Specification',
    value: `Consumers who do not ascribe any of the three media evaluation criteria to the given medium.`,
  },
];
const MEDIAATTITUDEINTERNET = [
  {
    key: 'Relaxation Only',
    value: `Consumers who value a given medium exclusively for its ability to entertain.`,
  },
  {
    key: 'Inspiration Only',
    value: `Users of a medium who primarily value the given medium as a source of good ideas and as a provider of 
    information about new products, styles and trends.`,
  },
  {
    key: 'Information Only',
    value: `Consumers who value a given medium only for its ability to provide news or information.`,
  },
  {
    key: 'Relaxation & Inspiration',
    value: `Those consumers who value the medium as an entertainment resource and as a source for new ideas.`,
  },
  {
    key: 'Relaxation & Information',
    value: `Those media users who value the given medium as both an entertainment resource and as a source for news or
     information.`,
  },
  {
    key: 'Information & Inspiration',
    value: `Those users of a given medium who describe it as a good source for news or information and as a source of
     good ideas for products or trends.`,
  },
  {
    key: 'Three in One',
    value: `Those consumers who value a given medium for all three purposes—as an entertainment resource,
     as a source of news and information, and as a source of ideas or information about new trends and styles.`,
  },
  {
    key: 'No Specification',
    value: `Consumers who do not ascribe any of the three media evaluation criteria to the given medium.`,
  },
];
const MEDIAATTITUDENEWSPAPER = [
  {
    key: 'Relaxation Only',
    value: `Consumers who value a given medium exclusively for its ability to entertain.`,
  },
  {
    key: 'Inspiration Only',
    value: `Users of a medium who primarily value the given medium as a source of good ideas and as a provider of
     information about new products, styles and trends.`,
  },
  {
    key: 'Information Only',
    value: `Consumers who value a given medium only for its ability to provide news or information.`,
  },
  {
    key: 'Relaxation & Inspiration',
    value: `Those consumers who value the medium as an entertainment resource and as a source for new ideas.`,
  },
  {
    key: 'Relaxation & Information',
    value: `Those media users who value the given medium as both an entertainment resource and as a source for news or
     information.`,
  },
  {
    key: 'Information & Inspiration',
    value: `Those users of a given medium who describe it as a good source for news or information and as a source of 
    good ideas for products or trends.`,
  },
  {
    key: 'Three in One',
    value: `Those consumers who value a given medium for all three purposes—as an entertainment resource,
     as a source of news and information, and as a source of ideas or information about new trends and styles.`,
  },
  {
    key: 'No Specification',
    value: `Consumers who do not ascribe any of the three media evaluation criteria to the given medium.`,
  },
];

const MEDIAATTITUDEMOBILE = [
  {
    key: 'Relaxation Only',
    value: `Consumers who value a given medium exclusively for its ability to entertain.`,
  },
  {
    key: 'Inspiration Only',
    value: `Users of a medium who primarily value the given medium as a source of good ideas and as a provider 
    of information about new products, styles and trends.`,
  },
  {
    key: 'Information Only',
    value: `Consumers who value a given medium only for its ability to provide news or information.`,
  },
  {
    key: 'Relaxation & Inspiration',
    value: `Those consumers who value the medium as an entertainment resource and as a source for new ideas.`,
  },
  {
    key: 'Relaxation & Information',
    value: `Those media users who value the given medium as both an entertainment resource and as a source for
     news or information.`,
  },
  {
    key: 'Information & Inspiration',
    value: `Those users of a given medium who describe it as a good source for news or information and as a source 
    of good ideas for products or trends.`,
  },
  {
    key: 'Three in One',
    value: `Those consumers who value a given medium for all three purposes—as an entertainment resource,
     as a source of news and information, and as a source of ideas or information about new trends and styles.`,
  },
  {
    key: 'No Specification',
    value: `Consumers who do not ascribe any of the three media evaluation criteria to the given medium.`,
  },
];

const FOODANDLIFESTYLE = [
  {
    key: 'Convenience Eaters',
    value: `Want food that is fast, convenient, and easy to prepare and/or eat. They show little interest in cooking,
     healthy eating, or nutritional value. These eaters prefer picking up a prepared meal to spending time cooking
      at home.`,
  },
  {
    key: 'Reformed Eaters',
    value: `Have come to realize that they should make healthier choices in food rather than letting convenience 
    be the guiding force. They stay away from junk food, watch their fat intake, and always look for information
     about the food that they buy.`,
  },
  {
    key: 'Variety Budget Eaters',
    value: `Are very busy and frequently eat on the run. They see frozen food as a convenient alternative to
     preparing meals with fresh ingredients. They are interested in gourmet food - as long as it fits into their
      budget.`,
  },
  {
    key: 'True Foodies',
    value: `Passionate about food and spend a lot of time cooking at home. They prefer fresh ingredients and organic
     food and consider themselves culinary experts. Variety is the spice of their life, and they love to try different
      cuisines.`,
  },
  {
    key: 'Weekend Chefs',
    value: `Have some interest in cooking but are mostly sociable home chefs. When they can find time in their busy 
    schedule, they love to cook for friends and family. For this group, healthy food is tasty food, although they do
     indulge their cravings.`,
  },
];
const POLITICALPERSONA = [
  {
    key: 'Unregistered: Unconnected And Unregistered',
    value: '',
  },
  {
    key: 'Unregistered: Informed But Unregistered',
    value: '',
  },
  {
    key: 'Democrats: Super Democrats',
    value: '',
  },
  {
    key: 'Democrats: Left Out Democrats',
    value: '',
  },
  {
    key: 'Democrats: Conservative Democrats',
    value: '',
  },
  {
    key: 'Democrats: On The Fence Liberals',
    value: '',
  },
  {
    key: 'Republicans: Green Traditionalists',
    value: '',
  },
  {
    key: 'Republicans: Mild Republicans',
    value: '',
  },
  {
    key: 'Republicans: Uninvolved Conservatives',
    value: '',
  },
  {
    key: 'Republicans: Ultra Conservatives',
    value: '',
  },
];

const FOODSEGMENTS = [
  {
    key: 'Fast & Curious Foodies',
    value: `This segment is at the cutting edge of food culture. They are more likely to try any new diet, 
    experiment with the newest food trends and products, and are inspired by celebrity chefs. 
    Organic food and nutrition are important to them, but they’re willing to grab pre-made meals 
    for the sake of convenience.`,
  },
  {
    key: 'Healthy Home Cooks',
    value: `Consumers in this group eschew fast and junk food for healthy, home-made alternatives. 
    They have a collection of favorite recipes and rely on meal-planning to complement their busy lifestyles. 
    Coupons, both online and paper, can sway their purchases away from the familiar.`,
  },
  {
    key: 'Joy of Eating',
    value: `Adults in this segment are always on the hunt for new recipes and creative food inspiration, 
    with celebrity chefs being just one of their inspirations. They really enjoy cooking and tend to be 
    loyal to their favorite brands.`,
  },
  {
    key: 'Grab & Go Diners',
    value: `Convenience is key for this group, be it fast food, frozen dinners, or dinner “to go” from their 
    favorite restaurant. Healthy eating is less of a concern; they snack often, frequently eat sweets, 
    and indulge their cravings for favorite foods, especially those of familiar brands.`,
  },
  {
    key: 'Creative Chefs',
    value: `The kitchen is their favorite room in their house for the Creative Chefs; it’s where the magic takes place. 
    They really enjoy cooking and prefer preparing a meal at home to dining out. 
    Creativity and celebrity chefs are the inspiration behind their culinary creations.`,
  },
  {
    key: 'Farm to Table',
    value: `Health and sustainability power this segment. Organic, local, and ethically sourced foods drive their 
    purchasing behavior, but they also enjoy their snacks, sweets, 
    and an occasional indulgence on a quality bottle of wine.`,
  },
];

const GREENSEGMENTS = [
  {
    key: 'Green Bystanders',
    value: `This segment is green-neutral. They recognize that climate change and environmental issues 
    are important but are on the fence about their personal commitment to being green right now.`,
  },
  {
    key: 'My Products Scream Green',
    value: `Being green is a growing priority; they are interested in learning more about being 
    environmentally progressive. This group is starting with the little things – cleaning products, 
    recycled products – and are involved with environmental groups and causes.`,
  },
  {
    key: 'Green Averse',
    value: `The Green Averse segment has no interest in issues pertaining to the environment. 
    They think people who are worried about the environment are overreacting and believe climate 
    change has become too political of a topic.`,
  },
  {
    key: 'Next-Level Greens',
    value: `Being green is part of their identity; they will go out of their way to find green 
    products from green companies, even if they are more expensive. Their commitment to the environment 
    is reflected in their vehicle choices, use of mass transit, the causes they support, and their household products.`,
  },
  {
    key: 'It Ain’t Easy Being Green',
    value: `Being green is a challenge for the adults in this group. They do understand the importance 
    and relevance of environmental issues but feel helpless to effect change themselves.`,
  },
];

const FASHIONANDSTYLESEGMENTS = [
  {
    key: 'No Passion for Fashion',
    value: `Adults in this group have no interest in fashion. They see clothing as a utilitarian necessity 
    and will only shop for shoes and clothes when they absolutely need them.`,
  },
  {
    key: 'Fashionistas',
    value: `Making a unique and trendy fashion statement is key to this group’s image. 
    They like to experiment with new styles, mix and match low- and high-end fashion, 
    and are the first among their friends to try new clothing styles. They pay attention to 
    social media influencers and like to spend money to get the newest and best styles.`,
  },
  {
    key: 'Beauty Explorers',
    value: `Makeup, hairstyles, skin care, and their appearance define the Beauty Explorer segment. 
    They enjoy experimenting with new styles and are careful to maintain a youthful appearance. 
    They often shop for new beauty products online and look to social media for new ideas.`,
  },
  {
    key: 'Dress to Impress',
    value: `Celebrities, influencers, fashion, and beauty products are important to this group. 
    It’s all about the image, from upscale designer labels to the newest trends, this group is out to 
    impress others in terms of style, fashion, and makeup.`,
  },
  {
    key: 'Classic & Content',
    value: `Timeless and classic fashion drive consumers in this segment. They dress to please themselves 
    and focus on comfort rather than trends. They are not averse to shopping, but generally only 
    shop when they need to replace an item from their wardrobe.`,
  },
  {
    key: 'Designer-Driven',
    value: `The designer label matters to these consumers, as does their appearance, being attractive to 
    others, and maintaining a youthful appearance. They like to shop and spend, and their budget allows 
    them to buy high-quality designer fashion.`,
  },
];

const AUTOMOTIVESEGMENTS = [
  {
    key: 'American Auto Purists',
    value: `These American-leaning auto enthusiasts appreciate spirited, powerful vehicles with bold and 
    innovative designs. Having a vehicle that is fun to drive is a top priority. They are tinkerers as well, 
    paying attention to what goes on under the hood of their vehicles, 
    which they choose to reflect their personalities.`,
  },
  {
    key: 'Lease & Luxury',
    value: `Only the best will do for the members of this segment, and they consider cars to be a sign of 
    prestige – they are well-versed on the automotive industry and consider themselves auto enthusiasts. 
    Bold, innovative, and full of luxury options are the characteristics that matter, and price is 
    rarely an issue; they often prefer to lease because they can afford even more luxurious 
    automobiles that way and get a new one every couple of years.`,
  },
  {
    key: 'Alternative Transport',
    value: `Members of this group are ready, willing, and able to rely on alternative transportation 
    options and find owning a car to be less important because of this. To them, a car is a basic means 
    of transportation, but their commitment to the environment means that the choices 
    they do make will be more eco-friendly.`,
  },
  {
    key: 'New Car Hoppers',
    value: `The new car smell is an aphrodisiac for this segment. They like to get a new car every two 
    or three years and are big fans of leasing as they believe leasing allows them to get a better car for less money.`,
  },
  {
    key: 'Foreign Car Loyalists',
    value: `Foreign car quality and prestige drives this segment. They are very brand loyal to their chosen 
    ride and tend toward new car purchases. Being “green” also influences their vehicle choices.`,
  },
  {
    key: '4-Wheel Comfort & Utility',
    value: `Having a vehicle that can handle rough terrain is key, but they are also interested in comforts 
    and amenities in their vehicles. They feel that their vehicle should express their personality and are 
    willing to brand-hop to find the one that best reflects them.`,
  },
];

const DATAPRIVACYSEGMENTS = [
  {
    key: 'Data Diligents',
    value: `These hard-core investigative consumers perform due diligence about the companies they intend 
    to transact with, all in the spirit of better understanding how their data is going to be used. 
    They actively clear their browser history to protect and control the information about them. 
    They are willing to share information as long as they feel comfortable.`,
  },
  {
    key: 'Data Burned & Returned',
    value: `Consumers in this segment have had a negative experience with information about them online yet, 
    they remain unfazed and still feel some level of control over their data. The benefits of companies 
    using personal information far outweigh the costs as they find value in targeted advertising for 
    products and services, especially based on past purchase behavior. They also trust the federal 
    government to make the best decisions about data privacy.`,
  },
  {
    key: 'Data Anxious',
    value: `Data exposure is a concern for these consumers. They do not find sharing their data a willing 
    price to pay for more targeted advertising and information. They also feel there’s nothing they 
    can do once information is available about them online.`,
  },
  {
    key: 'Data Unconnected',
    value: `Adults in this segment are seemingly lackluster about data privacy as they are unlikely 
    to be online doing anything other than the most basic of tasks.`,
  },
  {
    key: 'Data Quid Pro Quo',
    value: `These conditional consumers are willing to provide information to get what they want. 
    As long as companies keep their identity private, they are comfortable with companies both using 
    their personal information and sharing their product preferences.`,
  },
];

const HISPANICCULTURALSEGMENTS = [
  {
    key: 'Bi-Cultural & Content',
    value: `Spanish language and heritage are important to this group, but they also say that being part 
    of American culture is important. They are comfortable with who they are and are proud to be part of both cultures.`,
  },
  {
    key: 'True Bi-Cultural',
    value: `Hispanics in this group truly have their feet in both worlds. They are proud of their Hispanic 
    roots (Spanish language is important on products and media) but consider themselves American as well. 
    Speaking both English and Spanish is a priority. They keep up with American news, 
    but equally with Hispanic news/sports.`,
  },
  {
    key: 'Hispanic First & Forever',
    value: `Hispanics in this segment rely heavily on Spanish language in media/advertising, and in the home. 
    They are proud of their heritage and want to show it. Continuing traditions and keeping up with 
    news/music/culture from Hispanic countries is key.`,
  },
  {
    key: 'All-American Hispanics',
    value: `Adults in this group are less likely to relate to their Hispanic heritage and have 
    embraced and become a part of American culture.`,
  },
  {
    key: 'Bi-Cultural & Evolving',
    value: `This group considers themselves more American but are proud of their heritage. 
    Although they speak more English at home, they realize their Hispanic heritage is an advantage 
    and want to reconnect with their roots.`,
  },
];

const TECHNOLOGYSEGMENTS = [
  {
    key: 'Tech Pragmatists',
    value: `Consumers in this group are practical about their technology and use it to benefit their lives. 
    They do pay attention to innovations in technology but like to do their research and read reviews 
    before buying anything new – and when they do buy, they prefer devices that work with what they already have.`,
  },
  {
    key: 'Connected Players',
    value: `Technology and internet connectivity is important for the Connected Players, especially as it 
    pertains to gaming. They are avid gamers who consider gaming their primary form of entertainment, 
    and they get their information about technology from friends and advertising.`,
  },
  {
    key: 'True Techies',
    value: `The techiest of the techies, adults in this group are always first to have the newest 
    and shiniest tech toys, games, and gadgets, hoping for the WOW! factor from those around them. 
    They are a source of tech information for friends and family because they are always on top of emerging technology.`,
  },
  {
    key: 'Tech Indifferent',
    value: `These adults see technology as a necessary evil, useful at times, but generally more complicated 
    than it needs to be. This group generally needs assistance to use their new devices but may embrace 
    new products if they are simple and easy to use.`,
  },
];

const VACATIONTRAVELSEGMENTS = [
  {
    key: 'Passionate Travel Adventurers',
    value: `Travel is a passion and a priority for this segment. They travel to seek adventure and thrills, 
    meet new people, and learn about new cultures. This group looks for vacation experiences different 
    from their friends, and they are called on by others to give advice on travel.`,
  },
  {
    key: 'Outdoor Travel Enthusiasts',
    value: `Consumers in this group are always up for a road trip and prefer driving over flying. 
    They like to travel off the beaten path, with an eye toward any adventure involving the outdoors. 
    OTEs like spontaneity, solo vacations, and active vacations with lots to do.`,
  },
  {
    key: 'Backyard Vacationers',
    value: `Vacationing at home or nearby is what makes this group happy; when and if they do travel, 
    the journey may be a short car trip to a nearby destination, preferably one they’ve been to before. 
    Vacation to them means rest and relaxation, not an organized schedule.`,
  },
  {
    key: 'Do-It-For-Me Vacationers',
    value: `Guided tours, packaged deals, and organized activities are the preferences for this segment; 
    they’d rather let someone else deal with the details. They prefer the familiar as well and will 
    book with an airline or hotel where they are loyalty/rewards members.`,
  },
  {
    key: 'Aspirational Travelers',
    value: `Aspirational Travelers have an endless bucket list of travel plans; this group dreams of travel 
    and is always fantasizing about their next vacation. Their ideal vacations run the gamut from fully 
    organized to spontaneous and everything in between.`,
  },
];

const MOBILESEGMENTS = [
  {
    key: 'Married to My Screen',
    value: `This group uses their phone for everything, and they say that apps have made their life more 
    convenient. They consider their device an extension of their personality, and it even can take precedence 
    over face-to-face conversations. They use their phones for shopping, entertainment, social media 
    (including following brands and companies), apps, and more, which includes 
    keeping in touch with friends and family.`,
  },
  {
    key: 'Serious Relationship with My Screen',
    value: `They are still in the infatuation stage and say that their phone may distract them from work. 
    They are likely to have the newest and shiniest phone as soon as they can (and may switch providers 
      to get this) and are always checking the app store for newer apps. When they use their phones for 
      shopping, they are interested in receiving ads for products.`,
  },
  {
    key: 'Casual Relationship with My Screen',
    value: `This segment appreciates the convenience of their phone and uses it to get the information 
    they need. When shopping, they use their phones to compare prices, get additional information about 
    products, and look for coupons or other offers.`,
  },
  {
    key: 'Basic Phone Buddy',
    value: `Basic Phone Buddies want to use their phones for basic communication; the other features 
    are an extraneous distraction and too complicated.`,
  },
];

const SOCIALMEDIA = [
  {
    key: 'Social Media Superstars',
    value: `This group lives and breathes by social media. They create content to share, trust social media
     for information, follow influencers, and say that social media is their primary news source. 
    They interact with their fellow social media users, commenting on posts, supporting issues and causes,
     making product recommendations, and say that social media improves their life overall.`,
  },
  {
    key: 'Social Media Connectors',
    value: `This segment relies on social media to stay connects with friends and family.
     They post updates about their lives, comment on others posts, and share memes,
      photos, and other content. Social media content also helps drive their face-to-face interactions.`,
  },
  {
    key: 'Social Media Group-ies',
    value: `These adults follow their favorite groups, brands, and celebrities on social media.
     Posts, brand content, and influencers drive their purchases, and they are also likely to share
      their opinions of brands and products on social media. They trust social media content and are more 
      likely to consider it one of their primary news sources.`,
  },
  {
    key: 'Social Media Cynics',
    value: `While active on social media, this group is wary of what they read.
     They say that social media makes them anxious and sad and realize that it is hard to get truly
      balanced information from these platforms. They tend to lurk and read others’ posts rather than
       interacting, as they feel that social media discourages genuine interaction. `,
  },
  {
    key: 'Social Media Reluctant',
    value: `Although this group is on social media, they tend to be uninvolved and relatively inactive
     compared with the other groups.`,
  },
  {
    key: 'Unclassified',
    value: `Not eligible for segment assignment.`,
  },
];

const CIVICPARTICIPATION = [
  {
    key: 'Political Change-Makers',
    value: `Deeply committed to and involved in the political process, this group
     indexes exceptionally high across a full range of political activities.
      Respondents in this segment are likely to contact politicians, attend a political rally,
      speech, or organized protest of any kind, attend a public meeting on town or school affairs,
      hold or run for political office, work for a political party, sign a petition,
      and/or be an active member of group that tries to influence public policy or government.`,
  },
  {
    key: 'Active Humanitarians',
    value: `Adults in this segment focus their civic participation on contributing to private foundations,
     typically in health or social services, and they tend to limit their other public or civic activities to voting,
      contacting politicians, and fundraising. They tend to shy away from more active forms of political involvement.`,
  },
  {
    key: 'Donating Activists',
    value: `The adults in this segment are passionate about the political process.
     They vote in all the elections, are involved at any and all levels of civic engagement,
      and like to show their support to organizations,
     both political and cultural, with their pocketbooks as well as their membership.`,
  },
  {
    key: 'Union Voters',
    value: `This segment always votes in local, state, and federal elections. They are generally involved in
     their local community and are likely to support military and educational organizations, but their
      political involvement is limited to attending meetings and writing letters or calling into radio stations.`,
  },
  {
    key: 'Locally Active',
    value: `This segment has a high level of interaction with groups and other people in their communities.
     They serve on local committees, as officers of local clubs and organizations,
      and engage in public fundraising at higher rates.`,
  },
  {
    key: 'Politically-Passive Traditionalists',
    value: `The older adults in this segment embrace their traditional, conservative, and religious values but have low
     voter participation They are not involved in political or civic activities, except for their church.`,
  },
  {
    key: 'Inactive Progressives',
    value: `The young adults in this segment skew slightly liberal but have low voter participation,
     although they do sometimes vote in national and state-wide elections. They tend to be uninvolved
      in political activities.`,
  },
];

export const FINANCIALWELLNESS = [
  {
    key: 'Measured Investors',
    value: `
    This group is financially astute when it comes to financial news and information; they are knowledgeable about
     financial products and share this information with others. They are on top of their investments and realize that
    with risk comes reward.`,
  },
  {
    key: 'Financial Newbies',
    value: `These consumers are inexperienced with the stock market and financial planning.
     They have little interest in financial news and information and are more concerned with the day-to-day
      aspect of their budget. `,
  },
  {
    key: 'Careful Money Managers',
    value: `This segment prefers to avoid any kind of financial risk; they pay attention to their credit score,
     actively plan for their retirement, and carry insurance to protect their belongings. They are active in managing
    their money and are diligent in monitoring their spending.`,
  },
  {
    key: 'Overextended Spenders',
    value: `This group is intrigued by the machinations of the financial markets; they are excited by the ups and downs
     of the market and are willing to take risks for the chance of a high return. To them, money equals success, and it
      is important that others see them as successful, despite the fact that they may feel overwhelmed by debt and
       wait for their tax refunds to make large purchases. `,
  },
  {
    key: 'Financial Underdogs',
    value: `This group tends to spend money without thinking. They are worried about saving for retirement along with their 
    current bills. Financial planning seems too complicated, but they are willing to listen to others when it comes to
     financial advice.`,
  },
];

export const FISCALOPTIMISM = [
  {
    key: 'Fiscal Optimists',
    value: `This group is confident about their current fiscal situation, as well as that of the US economy overall.
     They have positive expectations about the fiscal future as well.`,
  },
  {
    key: 'Fiscal Realists',
    value: `This pragmatic segment sees the reality, both good and bad, in the US economy as well as their own household fiscal picture.
     They tend to hope that the future will bring a higher sense of consumer confidence.`,
  },
  {
    key: 'Outlook Fiscally In Flux',
    value: `This group’s household finances have taken a hit over the past year, and they feel similarly about the economy as a whole. However,
     they are more likely to see the past patterns leveling off – not better, but not worse.`,
  },
  {
    key: 'Fiscal Pessimists',
    value: `The consumer confidence of this group is low. They see their household financial situation as worse than it was a year ago,
     and they are not hopeful about the future of the US economy or their own personal fiscal future.`,
  },
];

export const HEALTMANAGMENT = [
  {
    key: 'DIY Health',
    value: `This segment prefers to take control of their own health care; they do their own research and take advice from others
     who may have similar illnesses. When medical care is a necessity, they use options other than the doctor’s office,
      preferring mobile apps, video chats, or urgent care centers.`,
  },
  {
    key: 'Healthy Homeopaths',
    value: `This group is skeptical of doctors – they prefer getting medical advice from friends, pharmacists,
     or doing their own research. They prefer alternative and homeopathic medicine and herbal supplements over
      prescription drugs and like to exercise and eat a healthy diet.`,
  },
  {
    key: 'Pharma Fans',
    value: `The Pharma Fans fully embrace prescription medicine as a way to manage their health and illnesses.
     They are willing to pay more for brand name drugs and are always looking for the newest, best,
      or most popular cure for what ails them.`,
  },
  {
    key: 'Doctor Devotees',
    value: `This segment is wary of Big Pharma but trusts their physician – whether the meeting is in person
     or via video chat – and will use drug brands that their doctor recommends. They are fit and active and
      consider their diet to be very healthy.`,
  },
  {
    key: 'Health-Challenged',
    value: `This group prefers brand-name medications, whether prescription or over-the-counter,
     and cost is never a barrier. They tend to pay little attention to nutrition, diet, or exercise and are 
     skeptical of vaccines.`,
  },
]

export const SHOPPINGANDBUYING = [
  {
    key: 'Free-Spirited Shoppers',
    value: `This group is likely to make impulse purchases and defines themselves as spenders rather than savers.
     If they really want something, be it the newest technology or the most environmentally friendly, they will
      buy it with credit rather than wait.`,
  },
  {
    key: 'Retail Therapy Shoppers',
    value: `To them, shopping is relaxing, and buying is not always the end goal. They frequent many stores and
     enjoy browsing stores looking at the various available options.`,
  },
  {
    key: 'Impressionable Buyers',
    value: `Celebrities, social media influencers, and the hottest new trends drive the purchase habits of this group.
     Variety in brands is their spice of life, and sponsorships and endorsements help sway their buying.`,
  },
  {
    key: 'Selective Buyers',
    value: `This conscientious group does their research before buying –looking for discount codes and comparing prices
     online. But price is not their only driver – they also prefer natural products for the sake of the environment
      and their family’s health.`,
  },
  {
    key: 'Loyal & Efficient Shoppers',
    value: `They see shopping as a necessity, not a pleasure. They stick to their favorite stores, with their favorite
     brands and predictable prices, and will only use coupons for brands that they usually buy.`,
  },
]


export const SEGMENTATION_CONTENT = {
  'Food Lifestyle': FOODLIFESTYLE,
  'Health And Well Being': HEALTHANDWELLBEING,
  'Retail Shopping': RETAILSHOPPING,
  'Mobile World': MOBILEWORLD,
  'Mobility Adoption': MOBILITYADOPTION,
  'Technology Adoption': TECHNOLOGYADOPTION,
  'Consumer Privacy': CONSUMERPRIVACY,
  'Economic Outlook': ECONOMICOUTLOOK,
  'Auto-motives': AUTOMOTIVES,
  'TV Product Placement': TVPRODUCTPLACEMENT,
  'Movie Product Placement': MOVIEPRODUCTPLACEMENT,
};

export const getSegmentationContent = study => {
  if (study.ss === 'SIMMONS') {
    return {
      'Food Lifestyle': FOODLIFESTYLE,
      'Health And Well Being': HEALTHANDWELLBEING,
      'Retail Shopping': RETAILSHOPPING,
      'Mobile World': MOBILEWORLD,
      'Mobility Adoption': MOBILITYADOPTION,
      'Technology Adoption': TECHNOLOGYADOPTION,
      'Consumer Privacy': CONSUMERPRIVACY,
      'Economic Outlook': ECONOMICOUTLOOK,
      'Auto-motives': AUTOMOTIVES,
      'TV Product Placement': TVPRODUCTPLACEMENT,
      'Movie Product Placement': MOVIEPRODUCTPLACEMENT,
    };
  }
  return {
    'Food Attitudes': FOODATTITUDES,
    'Health Attitudes': HEALTHATTITUDES,
    'Buying Styles': BUYINGSTYLE,
    'Political Personas': POLITICALPERSONA,
    'Mobile Attitudes': MOBILEATTITUDES,
    'Technology Attitudes': TECHNOLOGYATTITUDES,
    'General Attitudes': GENERALATTITUDES,
    'Financial Attitudes - Market Involvement & Savings': FINANCIALATTITUDESMARKETINVOLVEMENTSAVINGS,
    'Automotive Attitudes - Ideals': AUTOMOTIVEATTITUDESIDEALS,
    'Civic/Political Engagement': CIVICPOLITICALENGAGEMENT,
    'Green Attitudes & Behaviors': GREENATTITUDESBEHAVIORS,
    'Civic Engagement': CIVICENGAGEMENT,
    'Fashion & Style':
      study.pn >= 1001915 ? FASHIONANDSTYLESEGMENTS : FASHIONSTYLE,
    'Food and Lifestyle': FOODANDLIFESTYLE,
    'Auto-Motives': MRIAUTOMOTIVES,
    'Consumer Privacy': MRICONSUMERPRIVACY,
    'Economic Outlook': MRIECONOMICOUTLOOK,
    'Green Aware': GREENAWARE,
    'Health and Well-Being': MRIHEALTHANDWELLBEING,
    'Online Shoppers': ONLINESHOPPERS,
    'Techonology Adoption': MRITECHNOLOGYADOPTION,
    'Hispanic Acculturation Primary': HISPANICACCULTURATIONPRIMARY,
    'Hispanic Acculturation Transitional': HISPANICACCULTURATIONTRANSITIONAL,
    'Savings & Investing': SAVINGANDINVESTING,
    'Consumer Innovators': CONSUMERINNOVATORS,
    'Leisure Styles': LESISURESTYLES,
    'Vacation Preferences': VACATIONPREFERENCES,
    'Media Attitude - TV': MEDIAATTITUDETV,
    'Media Attitude - Radio': MEDIAATTITUDERADIO,
    'Media Attitude - Magazines': MEDIAATTITUDEMAGZZINES,
    'Media Attitude - Newspapers': MEDIAATTITUDENEWSPAPER,
    'Media Attitude - Internet': MEDIAATTITUDEINTERNET,
    'Media Attitude - Mobile': MEDIAATTITUDEMOBILE,
    Food: FOODSEGMENTS,
    Green: GREENSEGMENTS,
    Automotive: AUTOMOTIVESEGMENTS,
    'Data Privacy': DATAPRIVACYSEGMENTS,
    'Hispanic Cultural (Hispanic Respondents Only)': HISPANICCULTURALSEGMENTS,
    Technology: TECHNOLOGYSEGMENTS,
    'Vacation Travel': VACATIONTRAVELSEGMENTS,
    Mobile: MOBILESEGMENTS,
    'Social Media': SOCIALMEDIA,
    'Civic Participation': CIVICPARTICIPATION,
    'Financial Wellness': FINANCIALWELLNESS,
    'Fiscal Optimism': FISCALOPTIMISM,
    'Health Management': HEALTMANAGMENT,
    'Shopping & Buying': SHOPPINGANDBUYING,
  };
};

export const renderTooltip = data => {
  if (data) {
    return data.map(item => `<p>${TOOLTIP[item]}</p>`).join('<br />');
  }
  return false;
};

export const setQuickReportsDataOnSave = (preferences, dispatch, getState) => {
  const { study } = getState();
  if (preferences[PREFERENCE_QUICKREPORTS]) {
    if (
      (study.quickReportsStudy &&
        preferences[PREFERENCE_QUICKREPORTS]._ds !==
          study.quickReportsStudy.pn) ||
      (study.quickReportsStudy &&
        preferences[PREFERENCE_QUICKREPORTS][PREFERENCE_STUDY_WEIGHTING] !==
          study.quickReportsStudy.wt)
    ) {
      dispatch(setPreferenceFlag(QUICKREPORTS_CONSTANT, true));
    }
  }
};

export const getFormedTooltip = data => {
  let tooltip = '';
  const shortToolTip = data.map(item => {
    const value =
      item.objectType === 'operand' ? item.shortText : item.shortText;
    return value;
  });
  tooltip = shortToolTip.join(' ');
  if (tooltip.length < 46) {
    const tooltipValues = data.map(item => {
      const value =
        item.objectType === 'operand' ? item.breadcrumbs : item.keyword;
      return value;
    });
    tooltip = tooltipValues.join(' ');
  }
  return tooltip;
};
